// src/data/newsData.js
export const NEWS_EN = [
  {
    slug: "un-tax-proposal-on-cross-border-services-risks-backfiring",
    typeLabel: "News",
    taxonomy: "Taxation",
    dateLabel: "3 February 2026",
    title:
      "UN tax proposal on cross-border services risks backfiring on developing economies, new study finds",
    excerpt:
      "A new international tax provision endorsed by the United Nations Tax Committee of Experts could undermine growth and public revenues in developing economies, according to a new Oxford Economics study commissioned by the International Chamber of Commerce (ICC).",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2026/02/Economic-impact-article-12AA.png?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2026/02/Economic-impact-article-12AA.png?w=1080&h=1260&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "p",
        html:
          'The analysis finds that a proposed expansion of source-country taxing rights over cross-border services – Article 12AA of the UN Model Tax Convention – risks triggering an <strong>estimated&nbsp;US$241 million annual loss</strong> in&nbsp;government revenues in developing economies.',
      },
      {
        type: "p",
        html:
          "The provision allows countries to impose withholding taxes on any cross-border services even where the supplier has no physical presence in the market, and was adopted without any accompanying economic impact assessment, despite its potentially far-reaching implications applying to all industries.",
      },
      {
        type: "quote",
        html:
          "Article 12AA was adopted without any serious assessment of its impact on trade, investment or growth. Our analysis suggests that for developing economies in particular, the wider economic costs could significantly outweigh the revenues raised.",
        author: "Andrew Wilson, ICC Deputy Secretary General – Policy",
      },
      {
        type: "quote",
        html:
          "Cross-border services are not a peripheral activity – they are a core input into modern production, exports and value-chain integration. Policies that raise their cost risk weakening competitiveness and slowing diversification.",
        author: "Andrew Wilson, ICC Deputy Secretary General – Policy",
      },
      {
        type: "p",
        html:
          "ICC is urging governments to approach the adoption of Article 12AA with caution and to subject the provision to robust economic impact analysis before incorporating it into bilateral tax treaties or adopting similar provisions domestically.",
      },
      {
        type: "mediaText",
        bgClass: "has-blue-700-background-color",
        media: {
          src: "https://iccwbo.org/wp-content/uploads/sites/3/2024/09/Icc-logo-full-download-bloc.png?w=295",
          alt: "",
        },
        heading: "Economic impact of Article 12AA",
        cta: {
          label: "Download the report",
          href: "https://iccwbo.org/news-publications/report/economic-impact-of-article-12aa-new-un-tax-model-provision-on-cross-border-services/",
        },
      },
    ],
  },

  {
    slug:
      "icc-partners-with-leading-universities-to-launch-international-arbitration-module",
    taxonomy: "Dispute Resolution Services",
    dateLabel: "16 January 2026",
    title:
      "ICC partners with leading universities to launch International Arbitration Module",
    excerpt:
      "ICC Dispute Resolution Services has launched a partnership with universities in Brazil, China, Kenya, Qatar, and Chile to enhance arbitration education.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2026/01/Climbing-Toward-Knowledge.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2026/01/Climbing-Toward-Knowledge.jpg?w=1080&h=1260&crop=1",
    },
    blocks: [
      {
        type: "p",
        html:
          "The ICC International Arbitration Module will initially be rolled out at Wuhan University (China), Universidade de São Paulo (Brazil), Hamad Bin Khalifa University (Qatar), the University of Nairobi (Kenya), and Pontificia Universidad Católica de Chile (Chile), with more institutions expected to join in the coming months.",
      },
      {
        type: "p",
        html:
          "While traditional academic programmes tend to focus on theoretical legal frameworks, the ICC Arbitration Module will add a practical, hands-on element. The curriculum includes real-world case scenarios, practical exercises and specialised publications designed to bridge the gap between theory and practice.",
      },
      {
        type: "p",
        html:
          "Ruslan Mirzayev, Head of Education and Training at ICC Dispute Resolution Services, said:",
      },
      {
        type: "quote",
        html:
          "Through our collaboration with universities, we strive to make arbitration knowledge more accessible across the globe. With the support of the partner universities, this initiative aims to equip future lawyers with practical arbitration skills, help them make informed decisions and ensure that parties have access to high-quality legal services in different parts of the world.",
        author:
          "Ruslan Mirzayev, Head of Education and Training, ICC Dispute Resolution Services",
      },
      {
        type: "p",
        html:
          "The International Arbitration Module reflects ICC’s commitment to supporting the next generation of legal practitioners to enhance their skills as dispute resolution professionals. The initiative complements ICC’s existing and wide range of initiatives for students which includes the ICC Vis Pre-Moot, the ICC Mediation Competition, the ICC Dispute Resolution Universities Programme and now the International Arbitration Module.",
      },
    ],
  },

  {
    slug: "powering-the-clean-energy-future-in-the-philippines",
    taxonomy: "Environment and sustainability",
    dateLabel: "16 December 2025",
    title: "Powering the clean energy future in the Philippines",
    excerpt:
      "Meralco’s Long-term Sustainability Strategy charts a just and affordable path to a coal-free future by 2050.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/12/GettyImages-1357455726.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/12/GettyImages-1357455726.jpg?w=800&h=600&crop=1",
    },
    blocks: [
      {
        type: "mediaText",
        media: {
          src:
            "https://iccwbo.org/wp-content/uploads/sites/3/2025/12/Photo-Meralco-Chief-Sustainability-Officer-Raymond-B.-Ravelo-1.png?w=250",
        },
        heading: "Raymond B. Ravelo",
        subheading: "Chief Sustainability Officer, Meralco",
      },
      {
        type: "p",
        html:
          "Amid the intersecting challenges of climate change, rapid urbanisation and widening inequality, sustainability can no longer be a side goal – it must be core to everything we do.",
      },
      {
        type: "h3",
        text: "Our roadmap to becoming 100% coal-free by 2050",
      },
      {
        type: "list",
        items: [
          "Horizon 1 (2021–2030): Investing heavily in renewable energy by building capacity of over 1,500 MW.",
          "Horizon 2 (2031–2040): Accelerating the shift by developing and investing in next-generation technologies.",
          "Horizon 3 (2041–2050): Driving deep decarbonisation through carbon capture and carbon sink initiatives.",
        ],
      },
      {
        type: "p",
        html:
          "Together, these programmes form a blueprint for cities and communities to rise and prosper.",
      },
    ],
  },

  {
    slug:
      "how-brazils-renewable-power-is-fuelling-a-cleaner-future-for-transportation",
    taxonomy: "Climate action",
    dateLabel: "9 December 2025",
    title:
      "How Brazil’s renewable power is fuelling a cleaner future for transportation",
    excerpt:
      "Brazil’s clean power system gives it a unique edge in decarbonising transport.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/12/Electric-charging-sustainability.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/12/Electric-charging-sustainability.jpg?w=1080&h=1260&crop=1",
    },
    blocks: [
      {
        type: "mediaText",
        media: {
          src:
            "https://iccwbo.org/wp-content/uploads/sites/3/2025/12/221108_Rodolfo_Sirol-thumbnail.png?w=250",
        },
        heading: "Rodolfo Nardez Sirol",
        subheading: "Environment and Sustainability Director, CPFL Energia",
      },
      {
        type: "h3",
        text: "Brazil’s abundant renewable energy",
      },
      {
        type: "p",
        html:
          "Brazil stands out as one of the world’s most renewable-powered nations, with nearly 90% of its electricity generated from hydro, wind and solar sources.",
      },
      {
        type: "h2",
        text: "Our commitment to scaling success",
      },
      {
        type: "p",
        html:
          "Fleet electrification is more than a technological upgrade for CPFL Energia – it’s a cornerstone of the company’s ESG strategy.",
      },
    ],
  },

  {
    slug:
      "women-led-agribusinesses-are-trailblazing-climate-solutions-in-africa",
    taxonomy: "Climate action",
    dateLabel: "28 November 2025",
    title:
      "Women-led agribusinesses are trailblazing climate solutions in Africa",
    excerpt:
      "Robynne Anderson shares the stories of women agripreneurs driving climate action across Africa.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/icc-orange-header.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/icc-orange-header.jpg?w=800&h=534&crop=1",
    },
    blocks: [
      {
        type: "mediaText",
        media: {
          src:
            "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/Robynne-Anderson-thumbnail.png?w=250",
        },
        heading: "Robynne Anderson",
        subheading: "President, EmergingAg",
      },
      {
        type: "h2",
        text: "How women agripreneurs are powering climate action",
      },
      {
        type: "p",
        html:
          "Women agripreneurs across Africa are restoring land, reducing food waste and building resilient food systems.",
      },
      {
        type: "h2",
        text: "In Mali, Herou Alliance is restoring land and livelihoods",
      },
      {
        type: "p",
        html:
          "Herou Alliance has planted over 2,000 Moringa trees, contributing to reforestation and sustainable livelihoods.",
      },
    ],
  },

  {
    slug: "agricultural-transformation-starts-from-the-soil-up",
    taxonomy: "Climate action",
    dateLabel: "24 November 2025",
    title: "Agricultural transformation starts from the soil up",
    excerpt:
      "OCP Group is driving agricultural transformation through sustainable soil nutrient solutions.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/icc-agriculture-ground-soil.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/icc-agriculture-ground-soil.jpg?w=800&h=533&crop=1",
    },
    blocks: [
      {
        type: "mediaText",
        media: {
          src:
            "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/Meriem-El-Asraoui-thumbnail.png?w=250",
        },
        heading: "Meriem El Asraoui",
        subheading: "Chief Global Affairs Officer, OCP Group",
      },
      {
        type: "h2",
        text: "Sustainable soil nutrients as the foundation of transformation",
      },
      {
        type: "p",
        html:
          "The soil is the living foundation of agriculture and the starting point for climate-positive transformation.",
      },
      {
        type: "h2",
        text: "We’re investing US$13 billion in a green industrial strategy",
      },
      {
        type: "list",
        items: [
          "Green ammonia production powered by renewables",
          "Transition to 100% wind and solar energy by 2027",
          "Net-zero emissions across the value chain by 2040",
          "Use of 100% non-conventional water sources",
        ],
      },
    ],
  },
  {
  slug: "flying-towards-a-net-zero-future",
  taxonomy: "Climate action",
  dateLabel: "4 November 2025",
  title: "Flying towards a net-zero future",
  excerpt:
    "Decarbonising aviation is a monumental challenge, but it’s also an opportunity of a lifetime to reimagine how we travel. The journey to net zero will see aircraft powered by new propulsion systems, more electric designs and sustainable aviation fuel, SAF. Haldane Dodd, Executive Director, Air Transport Action Group (ATAG) calls for continued collective action to scale SAF production, accelerate deployment of fuel-efficient aircraft and invest in next-generation technologies – ensuring aviation continues to drive global connectivity while helping safeguard the planet for future generations.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/Air-Transport-Action-Group.jpg?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/Air-Transport-Action-Group.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "mediaText",
      bgClass: "has-grey-250-background-color",
      media: {
        src: "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/haldane-dodd-thumbnail.png?w=250",
        alt: "",
      },
      heading: "Haldane Dodd",
      subheading: "Executive Director • Air Transport Action Group",
    },
    {
      type: "p",
      html:
        "Climate change is the defining issue of our time. It affects the environment in many different ways, from sea level rise and permafrost impacts, high temperatures to flooding caused by stronger storms and coastal erosion. Every industry is rethinking its own operations and is forced to innovate and act decisively. For aviation, a sector that not only connects more than 4 billion people every year and accounts for almost 4% of global economic activity, but also contributes roughly 2% of global carbon emissions, the need to decarbonise is even more urgent.",
    },
    {
      type: "p",
      html:
        "This is why the global air transport sector is working towards achieving net zero carbon emissions by 2050. Yes, decarbonising a sector so heavily reliant on fossil fuels is a monumental challenge, but it also poses an opportunity as it allows us to reimagine the way we travel in the not-so-distant future: aircraft will be powered by new propulsion systems which reduce fuel use or rely on more electric architectures, while sustainable aviation fuel, or SAF, will need to fuel the majority of flights taking off around the world.",
    },
    {
      type: "p",
      html:
        "At the same time, smarter and more efficient airspace management and airport infrastructure and operations will transform air travel. The challenge of our lifetime to reach net zero carbon emissions, is the opportunity of our lifetime to create the next generation of air transport!",
    },

    { type: "h2", text: "Turning opportunity into reality" },

    {
      type: "p",
      html:
        "This is not just an ambition. Aviation’s net zero transformation is already underway – governments under the umbrella of the International Civil Aviation Organization (ICAO), support the sector’s 2050 goal. Airlines, airports, manufacturers, air navigation providers and the entire air transport value chain are taking action to lower carbon emissions.",
    },
    {
      type: "p",
      html:
        "But the way to get there is difficult, requiring enormous efforts by all stakeholders. There is no silver bullet to get to net zero and different stakeholders and regions in the world will contribute in different ways. Some will lead through large-scale deployment of sustainable aviation fuel, while others will pioneer hydrogen, hybrid and electric propulsion systems. Together, these efforts are converging into one shared journey: transforming the vision of tomorrow’s flight into today’s reality.",
    },
    {
      type: "p",
      html:
        "At the heart of this transformation lies the shift from fossil fuels to cleaner energy sources. Sustainable aviation fuel, which can be produced from feedstocks such as waste oils, agricultural residues, algae or even captured carbon, can reduce lifecycle emissions by up to 80%.&nbsp;But the challenge is to scale it: this fuel currently represents less than 1% of global jet fuel use. To meet 2050 targets, production must increase exponentially, requiring the creation of an entirely new energy ecosystem. That means new refineries and supply chains as well as harmonised regulations around the globe and investment and financial frameworks.",
    },

    {
      type: "embed",
      html:
        '<div class="flourish-embed fl-scrolly-wrapper" data-src="story/3419253?2927799"><script src="https://public.flourish.studio/resources/embed.js"></script><noscript><img decoding="async" src="https://public.flourish.studio/story/3419253/thumbnail" width="100%" pxalt="visualization" /></noscript><iframe scrolling="no" frameborder="0" title="Interactive or visual content" sandbox="allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation" style="width: 100%; height: 80vh;" src="https://flo.uri.sh/story/3419253/embed?auto=1"></iframe></div>',
    },

    { type: "h2", text: "Building the ecosystem for transformation" },

    {
      type: "p",
      html:
        "Air Transport Action Group(ATAG) is supporting the industry in reaching its net zero goals. Our member organisations share a vision of ensuring air transport can continue to connect the world and support economic and social development in the decades to come, while respecting the commitment to climate action. The case studies highlighted in this newsletter by organisations such as the Airports Council International and sustainable aviation fuel producers LanzaJet and World Energy demonstrate how the aviation industry is collaborating across the aisle, working with sustainable aviation fuel producers to move us closer to our target.",
    },
    {
      type: "p",
      html:
        "It shows that our common effort is by no means only limited to the aviation industry. We cannot decarbonise in a vacuum but need to work with the business community outside the aviation sector to create opportunities for climate impact. Apart from financial and energy industries this also includes businesses in the technology and construction industries, as well startups and research partners to innovate and help us scale new solutions.",
    },

    { type: "h2", text: "The next five years will define the future of flight" },

    {
      type: "p",
      html:
        "One thing is clear: we have the opportunity to create a net zero future for air transport, but time is short. The next five years will be decisive, and each year of delay makes net zero harder and more costly to achieve. Now is the time to collectively take on this opportunity and scale the production of sustainable aviation fuel globally, continue to implement market-based mechanisms and financing tools, deploy fuel-efficient aircraft faster into the fleet and continue research and development for new propulsion technologies.",
    },
    {
      type: "p",
      html:
        "We must continue to modernise air traffic management systems and accelerate the development and scaling of carbon removals. Doing so is essential not only for the planet, but also for protecting aviation’s role as a driver of global connectivity, trade, tourism and economic opportunity for communities around the world.",
    },
    {
      type: "p",
      html:
        "The decarbonisation of aviation can be a symbol of what multi-stakeholder cooperation and innovation can accomplish when the world works together towards a common goal. This is not just a challenge. It truly is the opportunity of a lifetime, to redefine how air transport connects the world and help safeguard the planet for generations to come.",
    },

    { type: "hr" },

    {
      type: "p",
      html:
        "<em>2025 is a critical year for the Paris Agreement. Ten years on, we need to rethink how we frame the challenge. And seeing challenges differently is what business and we are all about.</em>",
    },
    {
      type: "p",
      html:
        '<em>ICC is committed to securing what businesses need at the upcoming climate negotiations, COP30, in Belém, Brazil. Learn more about our&nbsp;</em><a href="https://iccwbo.org/global-insights/sustainability-and-climate-action/thebusinessofclimate/"><em>Opportunity of a Lifetime</em></a><em>&nbsp;climate campaign and how to get involved.</em>',
    },
    {
      type: "p",
      html:
        "<em>*Disclaimer: The content of this article may not reflect the official views of the International Chamber of Commerce. The opinions expressed are solely those of the authors and other contributors.</em>&nbsp;",
    },
  ],
},

{
  slug:
    "from-technological-progress-to-tackling-the-mounting-challenge-of-electronic-waste",
  taxonomy: "Climate action",
  dateLabel: "27 October 2025",
  title:
    "From technological progress to tackling the mounting challenge of electronic waste",
  excerpt:
    "Electronics have transformed modern life, but their afterlife tells a different story – a mounting e-waste crisis, the now fastest growing waste stream on Earth, with fewer than a quarter properly recycled. This is not only unsustainable but a lost opportunity, as billions of recoverable materials are discarded each year. Tomaso Manca of Hiro Robotics shows that the same technologies driving rapid innovation can also help us close the loop. Robotics and artificial intelligence can help to disassemble, recover and repurpose valuable components that power our digital world.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/icc-robotic-industrie-e1761557376559.jpg?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/icc-robotic-industrie-e1761557376559.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "mediaText",
      bgClass: "has-grey-250-background-color",
      media: {
        src: "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/Tomaso-thumbnail-icc-guestblog.png?w=523",
        alt: "",
      },
      heading: "Tomaso Manca",
      subheading: "Marketing and Communication Manager • Hiro Robotics",
    },

    {
      type: "p",
      html:
        "Over the last few decades, electronics have transformed our lives. Devices have become smaller, smarter and more connected, reshaping how we work, communicate and live. Yet one crucial question remains largely unanswered: what happens when technology reaches the end of its life?",
    },
    {
      type: "p",
      html:
        "While innovation has moved at lightning speed, the way we handle obsolete devices has not kept pace. The result is a rapidly growing environmental and economic challenge: electronic waste.",
    },
    {
      type: "p",
      html:
        "According to the Global E-Waste Monitor 2024, humanity generated 62 million tons of e-waste in 2022 – an 82% increase since 2010. Only 22.3% of that waste was formally collected and recycled in an environmentally sound way. The rest was landfilled, burned or processed informally.",
    },
    {
      type: "p",
      html:
        "E-waste is now the fastest-growing waste stream in the world, expanding about five times faster than documented recycling capacity. To visualise it, the annual pile of discarded electronics would fill roughly 1.55 million trucks, forming a line around the Earth’s equator.",
    },
    {
      type: "p",
      html:
        "Beyond volume, the hidden danger lies in toxic substances – mercury, lead, cadmium, brominated flame retardants – that harm workers, pollute soil and water, and enter food chains. Communities near informal recycling hubs such as Agbogbloshie in Ghana continue to face severe health risks, including respiratory diseases and heavy-metal poisoning.",
    },
    {
      type: "p",
      html:
        "At the same time, e-waste holds tremendous untapped value. The 2024 Monitor estimates that discarded electronics contained US$ 91 billion worth of recoverable materials – from gold and copper to rare earths – of which only about US$ 28 billion is currently recovered each. The problem, therefore, also contains its own solution.",
    },

    { type: "h2", text: "Building the conditions for change" },

    {
      type: "p",
      html:
        "Addressing electronic waste effectively requires more than technology alone. It depends on the interaction of five key pillars: regulation, infrastructure, economic viability, market sentiment and cooperation.",
    },

    { type: "h3", text: "1. Effective and forward-looking regulation" },
    {
      type: "p",
      html:
        "Robust policy frameworks – such as the EU’s Waste Electrical and Electronic Equipment Directive (WEEE) Directive and Extended Producer Responsibility (EPR) schemes – set the foundation for accountability and innovation. However, regulation must evolve beyond collection targets. It should encourage design for disassembly, modularity and traceable recycling processes that make end-of-life treatment both feasible and profitable.",
    },

    { type: "h3", text: "2. Infrastructure that connects every stage" },
    {
      type: "p",
      html:
        "Even the best recycling technology is useless without a reliable flow of material. Countries need a distributed network of collection and pre-treatment hubs that can aggregate and sort devices efficiently before they reach specialised recycling plants. Streamlined logistics lower costs, reduce emissions and enable local economies of scale.",
    },

    { type: "h3", text: "3. A viable economic model" },
    {
      type: "p",
      html:
        "Recycling will only thrive if it makes business sense. The balance depends on multiple factors: stable prices for secondary raw materials, internalisation of environmental costs for polluting alternatives, growing demand for certified recycled inputs and modular technologies that can adapt across different waste categories.",
    },
    {
      type: "p",
      html:
        "When these forces align, circular innovation becomes self-reinforcing rather than subsidised.",
    },

    { type: "h3", text: "4. Market sentiment and responsible procurement" },
    {
      type: "p",
      html:
        "Corporate buyers and public authorities hold significant power. By requiring transparency, traceability and recycled content in the products they purchase, they can reshape the economics of recovery. Procurement can drive a cultural shift: waste management stops being a regulatory obligation and becomes a competitive differentiator.",
    },

    { type: "h3", text: "5. Cross-sector cooperation" },
    {
      type: "p",
      html:
        "No single actor can solve the e-waste crisis. Governments, producers, recyclers and research institutions must collaborate to create open standards, share data and co-invest in pilot projects. This cooperative approach transforms fragmented efforts into a coherent system – one capable of scaling both innovation and impact.",
    },
    {
      type: "p",
      html:
        "When these five elements balance each other, technology can finally find fertile ground to make a lasting difference.",
    },

    { type: "h2", text: "Turning robotics and AI into tools for circularity" },

    {
      type: "p",
      html:
        "At Hiro Robotics, we believe that the technologies once designed to build new products can – and should – be adapted to disassemble them at the end of their life.",
    },
    {
      type: "p",
      html:
        "Today, most e-waste is either dismantled manually – a slow, risky process for operators – or shredded indiscriminately, which destroys valuable components and mixes hazardous materials. Robotics and artificial intelligence offer a third path: selective, intelligent disassembly.",
    },
    { type: "p", html: "This approach guides Hiro’s research and industrial systems:" },

    {
      type: "list",
      items: [
        "<strong>Hiro TEIA</strong> disassembles flat-panel displays such as TVs and monitors, automating one of the most delicate and dangerous recycling tasks.",
        "<strong>Hiro MAIA</strong> unscrews and separates industrial and telecom devices, such as servers and network modules, recovering intact components.",
        "<strong>Hiro NISA</strong> uses computer vision and AI sorting to classify printed-circuit boards by material and residual value.",
      ],
    },

    {
      type: "p",
      html:
        "Each system translates a circular-design philosophy into industrial practice: maximising recovery, minimising risk, and providing data for material traceability.",
    },
    {
      type: "p",
      html:
        "Our R&amp;D team continues to extend these methods to more complex products, such as electric-vehicle batteries and tightly sealed consumer devices. Yet even with advanced technology, success depends on broader alignment: companies must be willing to evolve their processes and policymakers must create frameworks that reward sustainable transition.",
    },

    { type: "h2", text: "Beyond the ‘dark side’ of technology" },

    {
      type: "p",
      html:
        "Electronic waste is often seen as the dark side of progress – a consequence of our appetite for innovation. But technology itself is not the enemy. When guided by thoughtful regulation, smart infrastructure, sound economics and cross-sector collaboration, technology can become a key part of the solution.",
    },
    {
      type: "p",
      html:
        "Robotics and AI can help us see waste differently: not as a by-product of consumption, but as a resource stream to be managed intelligently.",
    },
    {
      type: "p",
      html:
        "The global e-waste challenge is enormous – 62 million tons and growing – but so is the opportunity. If we act collectively, the same ingenuity that created our digital world can help us repair it: turning discarded electronics into the raw material for a truly circular future.",
    },

    { type: "hr" },

    {
      type: "p",
      html:
        "<em>2025 is a critical year for the Paris Agreement. Ten years on, we need to rethink how we frame the challenge. And seeing challenges differently is what business and we are all about.</em>",
    },
    {
      type: "p",
      html:
        '<em>ICC is committed to securing what businesses need at the upcoming climate negotiations, COP30, in Belém, Brazil. Learn more about our&nbsp;</em><a href="https://iccwbo.org/global-insights/sustainability-and-climate-action/thebusinessofclimate/"><em>Opportunity of a Lifetime</em></a><em>&nbsp;climate campaign and how to get involved.</em>',
    },
    {
      type: "p",
      html:
        "<em>*Disclaimer: The content of this article may not reflect the official views of the International Chamber of Commerce. The opinions expressed are solely those of the authors and other contributors.</em>&nbsp;",
    },
  ],
},

{
  slug: "the-future-of-energy-is-built-on-new-business-models-not-just-new-tech",
  taxonomy: "Environment and sustainability",
  dateLabel: "20 October 2025",
  title: "The future of energy is built on new business models, not just new tech",
  excerpt:
    "Soaring electricity demand is straining a 20th-century grid built for a different world. Keith Norman, Chief Sustainability Officer at Lyten, argues that the energy transition hinges on new business models, not just new technology. From decentralised storage to 85% mining-free lithium–sulphur batteries, Lyten is reimagining energy infrastructure to enable abundant, cleaner power for the 21st century.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/icc-battery-dark.jpg?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/icc-battery-dark.jpg?w=800&h=494&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "mediaText",
      bgClass: "has-grey-250-background-color",
      media: {
        src: "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/keith-photo-guest-blog.png?w=524",
        alt: "",
      },
      heading: "Keith Norman",
      subheading: "Chief Sustainability Officer • Lyten",
    },

    {
      type: "h2",
      text:
        "Keith, the world is facing what you’ve called “the largest ramp-up in electricity use ever.” How does Lyten view this surge in demand; is it a risk or a strategic opportunity?",
    },
    {
      type: "p",
      html:
        "<strong>Keith</strong>: Risk and opportunity are two sides of the same coin. Global electricity demand will nearly double in the next 25 years, driven by AI/data centres and emerging economies, which are projected to account for approximately 80% of the increase by 2040.&nbsp;",
    },
    {
      type: "p",
      html:
        "Realistically, meeting this demand will require an ‘all-of-the-above’ energy portfolio, including fossil fuels and renewables. But the real challenge is in distribution. Expanding transmission lines is a slow and costly process, tied up in decades-long permitting battles.&nbsp;",
    },
    {
      type: "p",
      html:
        "The risk is defined by inaction and working within legacy models for commercial, financing, permitting and policy. Technological innovation alone isn’t enough. The best analogue from my lifetime is the leap to cellular. Entire continents with little communication via landlines were connected within a decade, not because we built more land lines, but because cellular technology created an entirely new model. We need the same thinking in energy. The opportunity lies in taking proactive, collaborative action on the energy transition.&nbsp;",
    },

    { type: "spacer", px: 20 },

    {
      type: "h2",
      text:
        "You end with a call for a new model for energy. What are the key constraints of the old energy model and how does Lyten’s strategy provide a path forward?",
    },
    {
      type: "p",
      html: "<strong>Keith</strong>: We see two big opportunities.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "<strong>The first involves the grid.</strong> On the generation side, renewables have expanded rapidly, but grid dependence prevents fully bringing that capacity online. Our grid was designed for steady, centralized power plants, but it struggles with the intermittent, decentralised nature of modern renewables. This mismatch creates bottlenecks, forcing us to waste clean energy because it can’t get to the right place at the right time.&nbsp;",
    },
    {
      type: "p",
      html:
        "We believe a big part of the solution is adding decentralised energy storage at the edge of the grid, where electricity is consumed. This bypasses bottlenecks and makes renewables reliable 24/7, elevating batteries from ‘climate tech’ to critical energy infrastructure. Based on ExxonMobil’s 2024 energy report, the world will need to scale an additional 20,000 TWh of electricity generation by 2050. To put that in perspective, that is equivalent to two-thirds of the entire world’s current output, which Ember Energy reports finally broke 30,000 TWh in 2024 after over a century. Renewables plus batteries are projected to meet 85% of that new demand. That is why we are incredibly bullish on the role of batteries over coming decades: they are the key to enabling this transition by providing cleaner energy where and when it’s needed most.&nbsp;",
    },
    {
      type: "p",
      html:
        "<strong>The second opportunity is the supply chain.</strong> Today, batteries depend on massive mining and minerals processing operations. To meet transition goals, Benchmark Minerals suggest we’d need upwards of around 400 new mines in a decade. That’s unrealistic and environmentally damaging. Compounding this, geopolitical concentration in the battery supply chain sends materials on a 50,000-mile global tour for processing and assembly, concentrating risk, cost and carbon in a product meant to be sustainable. We saw this play out with solar panels, where regional monopolies led to the deep PV dependencies today.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "<strong>Lyten’s approach is to remove mined minerals from the battery supply chain.</strong> Our lithium-sulphur battery removes about 85% of mined mineral content, including nickel, cobalt, manganese and graphite. We see a pathway to over 90% mining-free batteries using lithium from brines. Shifting to abundant, locally sourced materials is the way to leap batteries forward. We believe lithium-sulphur is the chemistry that will lead the way; it’s a more energy dense battery, using lower cost materials and massively diversifies and secures our battery supply chain.",
    },

    { type: "spacer", px: 20 },

    {
      type: "h2",
      text:
        "Lyten’s vision extends far beyond energy. Could you give us another example of how Lyten is tackling hard-to-abate sectors?",
    },
    {
      type: "p",
      html:
        "<strong>Keith</strong>: Absolutely. We’re also using our materials platform to decarbonise physical infrastructure. A prime example is concrete. Cement is a major climate problem, responsible for 8% of global CO2 emissions. We’re addressing this with a new admixture that makes concrete 30% stronger. This delivers two wins: the enhanced strength extends the lifespan of infrastructure and, crucially, you can use significantly less cement, which slashes the carbon footprint.&nbsp;",
    },
    {
      type: "p",
      html:
        "We’re already seeing strong demand because the product solves customers’ primary performance and cost challenges. This validates our core belief that for a sustainable solution to achieve mass adoption, it must first be the better performing and more economical option. For builders, stronger infrastructure with less cement is an economic win. The CO2 reduction is a major co-benefit. That’s the power of our core material innovation. It works across industries, from batteries to buildings.&nbsp;",
    },

    { type: "spacer", px: 20 },

    {
      type: "h2",
      text:
        "Looking forward, what is the one key message you would want global business and policy leaders to take away?",
    },
    {
      type: "p",
      html:
        "<strong>Keith:</strong> We need to break out of old ways of thinking. Even as renewables and batteries surge, energy infrastructure has relied on the same centralised model for 75 years, which is no longer enough. Supplying cleaner, more reliable electricity will demand innovation not only in technology, but in business models, financing and policy.&nbsp;",
    },
    {
      type: "p",
      html:
        "At Lyten, we’re already seeing how pairing new battery systems with creative financing unlocks entirely new markets. The incredible demand we are seeing for our battery energy storage systems in emerging economies would be impossible without the supportive financing model we received from the US Export-Import Bank. Technology alone cannot solve the transition. Pairing it with scalable financing makes all the difference.&nbsp;",
    },
    {
      type: "p",
      html:
        "The single message I’d leave with global business and policy leaders is this: the energy transition is not about replacing fuels; it’s about re-architecting the system to enable abundant, clean energy. We need leaders who can think creatively across that entire value chain, from materials science to project finance to partnerships and policy. Incremental improvements help but are not enough to get us there; we need bold commitments that pay off not only next quarter, but for decades to come.&nbsp;&nbsp;",
    },

    { type: "hr" },

    {
      type: "p",
      html:
        "<em>2025 is a critical year for the Paris Agreement. Ten years on, we need to rethink how we frame the challenge. And seeing challenges differently is what business and we are all about.</em>&nbsp;",
    },
    {
      type: "p",
      html:
        '<em>ICC is committed to securing what businesses need at the upcoming climate negotiations, COP30, in Belém, Brazil. Learn more about our </em><a href="https://iccwbo.org/global-insights/sustainability-and-climate-action/thebusinessofclimate/" target="_blank" rel="noreferrer noopener"><em>Opportunity of a Lifetime</em></a><em> climate campaign and how to get involved.</em>&nbsp;',
    },
    {
      type: "p",
      html:
        "<em>*Disclaimer: The content of this article may not reflect the official views of the International Chamber of Commerce. The opinions expressed are solely those of the authors and other contributors.</em>&nbsp;&nbsp;&nbsp;",
    },
  ],
},


  {
    slug: "the-compliance-divide-how-ai-can-close-the-gap-between-policy-and-producers",
    taxonomy: "Climate action",
    dateLabel: "16 September 2025",
    title: "The compliance divide: How AI can close the gap between policy and producers",
    excerpt:
      "Understanding complex environment and sustainability rules can mean the difference between being locked out of markets and being part of the climate transition. In this guest blog, Niki Lewis, Chief Sustainability Officer at Bext360, shows how their new AI tool can turn dense regulations into simple, mobile-first tasks, giving smallholders and cooperatives the opportunity to stay connected to global markets, while giving brands and regulators the credible data they need.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/09/icc-ia-smes-sustainability.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/09/icc-ia-smes-sustainability.jpg?w=1080&h=1260&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "mediaText",
        bgClass: "has-grey-250-background-color",
        media: {
          src: "https://iccwbo.org/wp-content/uploads/sites/3/2025/09/niki-lewis-round-hs.png?w=308",
          alt: "",
        },
        content: "<strong>Niki Lewis</strong><br/>Chief Sustainability Officer at Bext360",
      },
      {
        type: "p",
        html:
          "When policymakers in Brussels draft new sustainability rules, the intention is clear: hold companies accountable for their environmental and social impact. The EU Deforestation Regulation (EUDR) and the Corporate Sustainability Reporting Directive (CSRD) are the latest examples of Europe’s leadership in climate policy. But for millions of smallholder farmers across Latin America, Africa and Asia, these laws can feel less like progress and more like a barrier.",
      },
      {
        type: "p",
        html:
          "The uncomfortable truth is that well-meaning regulations risk shutting producers out of global markets unless we close the compliance divide.",
      },
      { type: "h2", text: "The producer’s perspective" },
      {
        type: "p",
        html:
          "For a brand in Europe, compliance is an obligation. For a producer in Ethiopia, Honduras or Madagascar, compliance is a passport to the global economy. Without it, their products can’t be sold.",
      },
      {
        type: "p",
        html:
          "But most producers don’t have compliance officers or legal teams. They don’t have the resources to interpret hundreds of pages of EU law. They don’t have GIS experts to map their farms or auditors to document every labor contract. What they have are mobile phones, a patchy internet connection and an urgent need to keep exporting the crops their livelihoods depend on.",
      },
      { type: "h2", text: "Bridging the divide with AI" },
      {
        type: "p",
        html:
          "This is where technology can make the difference between inclusion and exclusion. At Bext360, we’ve developed an AI compliance tool, Ethica, that takes the dense text of regulations like the EUDR and turns it into actionable tasks for producers.",
      },
      {
        type: "p",
        html:
          "Instead of asking a farmer to ‘prove deforestation-free origin,’ the system prompts them to upload a GPS polygon of their plot. Instead of requiring a lengthy social report, the platform asks a cooperative to log basic labour data through a mobile form. Each entry is time-stamped, geolocated and stored immutably on blockchain.",
      },
      {
        type: "p",
        html:
          "For the farmer, the task takes minutes. For the brand, it creates a verifiable compliance record. For regulators, it delivers the credible data they need.",
      },
      { type: "h2", text: "Closing the divide" },
      {
        type: "p",
        html:
          "If sustainability legislation is to succeed, it must bridge the gap between policy and practice. AI-driven compliance platforms are one of the few ways to achieve that at scale.",
      },
    ],
  },

{
  slug: "how-is-biodiversity-shaping-the-future-of-business",
  taxonomy: "News",
  dateLabel: "22 May 2025",
  title: "How is biodiversity shaping the future of business?",
  excerpt:
    "On today’s International Biodiversity Day, we’re answering three key questions inspired by this year’s theme “Harmony with nature and sustainable development”.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/11/GettyImages-1405452705.jpg?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/11/GettyImages-1405452705.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "h2",
      text: "Can there be business without biodiversity?",
    },
    {
      type: "p",
      html:
        "No. Biodiversity underpins our collective survival, well-being and global economy.",
    },
    {
      type: "p",
      html:
        "According to research, over half of the world’s GDP is moderately or highly dependent on nature and what it has to offer.",
    },
    {
      type: "p",
      html:
        "The good news is that the critical role of nature is being increasingly recognised in decisions made by businesses and financial institutions across their operations, value chains and investments.",
    },
    {
      type: "h2",
      text: "How can economic development and natural preservation go hand in hand?",
    },
    {
      type: "p",
      html:
        "One way we can enable economic development and the preservation of our natural environment is by promoting the sustainable use of biodiversity, which is a key pillar of the Convention on Biological Diversity (CBD).",
    },
    {
      type: "columns",
      columns: [
        [
          {
            type: "p",
            html:
              "<strong>Companies</strong> are increasingly seeking ways to play their role in creating economic opportunities while fulfilling their responsibilities towards society and the environment.",
          },
        ],
        [
          {
            type: "p",
            html:
              "<strong>And what can governments do?</strong><br/>Governments can design supportive policies that encourage companies to adapt their operations and strategies in a way that biodiversity is maintained.",
          },
        ],
      ],
    },
    {
      type: "quote",
      html:
        "<strong>Businesses can and should be part of the solution to find paths to ensure that economic development is sustainable and in harmony with nature.</strong>",
    },
    {
      type: "h2",
      text: "And what is the role of research and innovation?",
    },
    {
      type: "p",
      html:
        "Research and innovation is one way of making sustainable use of biodiversity to develop knowledge and solutions to tackle societal and environmental challenges.",
    },
    {
      type: "p",
      html:
        "As the institutional representative of over 45 million companies worldwide, ICC is working with governments and other stakeholders to develop enabling frameworks for companies to share benefits from the use of biodiversity.",
    },
  ],
},

{
  slug: "business-responds-to-us-reciprocal-tariff-plan",
  taxonomy: "News",
  dateLabel: "2 April 2025",
  title: "Business responds to US reciprocal tariff plan",
  excerpt:
    "Following the announcement of the US reciprocal tariff plan, the International Chamber of Commerce has issued a statement describing the new measures as a shock to the global trading system.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2019/03/john-denton-world-chambers-twitter.jpg?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2019/03/john-denton-world-chambers-twitter.jpg?w=1024&h=512&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "Speaking on behalf of more than 45 million companies in over 170 countries, ICC Secretary General John W.H. Denton AO said:",
    },
    {
      type: "quote",
      html:
        "What we’ve seen today represents a watershed moment in American trade policy that poses severe downside risks to the global economy.",
    },
    {
      type: "p",
      html:
        "This is, without doubt, a shock to the global trading system but it need not result in a systemic crisis.",
    },
    {
      type: "p",
      html:
        "Businesses across our network will be seeking urgent clarification from the relevant US authorities on how new country-level tariffs will be applied in practice.",
    },
    {
      type: "p",
      html:
        "Predictability and certainty are fundamental to cross-border commerce. Multilateral solutions will ultimately be needed to resolve longstanding inefficiencies.",
    },
    {
      type: "contact",
      name: "Dawn Chardonnal",
      role: "Head of Global Communications",
      phone: "(+33) 1 49 53 29 07",
      email: "dawn.chardonnal@iccwbo.org",
    },
  ],
},
{
  slug: "guest-blog-navigating-cross-border-disputes-in-mena",
  taxonomy: "Arbitration and ADR",
  dateLabel: "11 February 2025",
  title: "Navigating cross-border disputes in MENA",
  excerpt:
    "In today’s interconnected world, cross-border disputes have become increasingly prevalent, particularly in the MENA region, where diverse legal frameworks and cultural nuances intersect.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2023/03/icc-dispute-resolution-services-discussion.jpg?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2023/03/icc-dispute-resolution-services-discussion.jpg?w=1080&h=1236&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "h2",
      text: "Overcoming legal complexities",
    },
    {
      type: "p",
      html:
        "Cross-border disputes often involve multiple jurisdictions, each with distinct legal principles. The MENA region, with its unique combination of civil law, common law, and Sharia principles, presents additional challenges for arbitration.",
    },
    {
      type: "p",
      html:
        "Successfully navigating these disputes demands a deep understanding of local and international arbitration rules, including the ICC framework.",
    },
    {
      type: "h2",
      text: "Strategic approaches to cross-border arbitration",
    },
    {
      type: "p",
      html:
        "Effectively managing cross-border disputes requires a proactive and strategic approach.",
    },
    {
      type: "list",
      items: [
        "<strong>Early risk assessment</strong>: Evaluating potential risks and liabilities",
        "<strong>Tailored advocacy</strong>: Aligning strategy with jurisdictional specifics",
        "<strong>Efficient resource management</strong>: Using multidisciplinary teams",
        "<strong>Collaboration with local counsel</strong>: Leveraging local expertise",
      ],
    },
    {
      type: "h2",
      text: "Case example: arbitration support for a large-scale infrastructure project",
    },
    {
      type: "p",
      html:
        "A major infrastructure project valued at over QAR 15 billion required reconciling conflicting contractual provisions under multiple legal frameworks.",
    },
    {
      type: "p",
      html:
        "Through thorough preparation and strategic advocacy, the dispute was resolved favourably.",
    },
    {
      type: "h2",
      text: "Conclusion",
    },
    {
      type: "p",
      html:
        "Navigating cross-border disputes in the MENA region requires expertise, strategic insight and a nuanced understanding of regional complexities.",
    },
    {
      type: "p",
      html:
        "<em>*Disclaimer: The content of this article may not reflect the official views of the International Chamber of Commerce.</em>",
    },
  ],
},

{
  slug: "calling-all-small-business-champions-of-the-circular-economy",
  taxonomy: "SME and entrepreneurship",
  dateLabel: "30 January 2025",
  title: "Calling all small business champions of the circular economy",
  excerpt:
    "Organisations championing the circular economy in the small business community have until 28 March to enter the globally recognised 2025 Small Business Champions Initiative competition.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2023/06/Office-eomployees-work-culture.jpg?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2023/06/Office-eomployees-work-culture.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "Launched in 2021, the Small Business Champions Initiative celebrates organisations that empower small businesses to participate and succeed in global trade.",
    },
    {
      type: "p",
      html:
        "The 2025 edition will recognise initiatives helping small businesses embrace the circular economy.",
    },
    {
      type: "h2",
      text: "What are we looking for and who can participate?",
    },
    {
      type: "list",
      items: [
        "<strong>Organisations</strong> leading awareness, training and mentoring initiatives",
        "<strong>Small businesses</strong> with innovative circular economy business models",
      ],
    },
    {
      type: "p",
      html:
        "All proposals must have a clear link to international trade and include an action plan.",
    },
    {
      type: "h2",
      text: "Submit your proposal",
    },
    {
      type: "p",
      html:
        "Proposals should be submitted through the official application form by 28 March 2025.",
    },
    {
      type: "image",
      src:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/01/small-business-champions-2025-icc.png?w=1024",
      alt: "",
    },
  ],
},
{
  slug: "how-business-shaped-the-internet-governance-forum-2024",
  taxonomy: "Internet policy",
  dateLabel: "19 December 2024",
  title: "How business shaped the Internet Governance Forum 2024",
  excerpt:
    "The Internet Governance Forum is the only global forum hosting open and inclusive discussions on Internet governance and digital policies.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/12/2024-2-ICC-IGF-Riyadh-Photo-by-IGF.jpg?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/12/2024-2-ICC-IGF-Riyadh-Photo-by-IGF.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "The Internet is evolving. And so must the way we govern it. This year’s theme “Building Our Multistakeholder Digital Future” emphasised the critical role of collaboration among all stakeholders.",
    },
    {
      type: "h2",
      text: "Is your business affected by Internet governance?",
    },
    {
      type: "p",
      html:
        "Regardless of sector, size or location, all businesses are affected by Internet governance and policies developed to ensure the stable functioning and sustainable growth of our digital world.",
    },
    {
      type: "h2",
      text: "How business made a difference at #IGF2024",
    },
    {
      type: "p",
      html:
        "Represented by the Business Action to Support the Information Society (ICC BASIS) and ICC national committees, global business contributed to Internet policy decisions in several ways.",
    },
    {
      type: "p",
      html:
        "<strong>Provided business recommendations on pressing digital policy issues</strong>",
    },
    {
      type: "p",
      html:
        "ICC BASIS organised public-facing sessions and presented papers on strengthened digital cooperation, data free flow with trust, evolving AI governance and protecting critical infrastructure.",
    },
    {
      type: "p",
      html: "The sessions called for action to:",
    },
    {
      type: "list",
      items: [
        "<strong>Align</strong> existing global governance approaches through multistakeholder cooperation.",
        "<strong>Create</strong> adaptable, interoperable policies that enable data free flow with trust.",
        "<strong>Adopt</strong> a future-proof, risk-based approach to AI governance.",
        "<strong>Strengthen</strong> the resilience of critical infrastructures through aligned cybersecurity efforts.",
      ],
    },
    {
      type: "p",
      html: "<strong>Forged powerful partnerships</strong>",
    },
    {
      type: "p",
      html:
        "ICC BASIS members connected with governments, international organisations, civil society and the technical community to discuss the Global Digital Compact and WSIS+20 in 2025.",
    },

    {
      type: "accordion",
      items: [
        {
          title: "What is your biggest takeaway from this year’s IGF?",
          html:
            "‘’It was inspiring to see how engaged everyone was in discussions that prioritise a safe, inclusive Internet…’’ <strong>Jessica Reed, Global Policy Assistant, ICC</strong>",
        },
        {
          title: "How will the insights you’ve gained impact ICC’s work?",
          html:
            "“The insights gained from the valuable dialogues at IGF 2024 will guide our work…” – <strong>Timea Suto, Global Digital Policy Lead, ICC</strong>",
        },
        {
          title: "Why is business engagement at the IGF crucial?",
          html:
            "‘’With the collaborative model of the IGF set for review in 2025…’’ – <strong>Meni Anastasiadou, Digital Policy Manager, ICC</strong>",
        },
      ],
    },
    {
      type: "h2",
      text: "Gearing up for the Internet Governance Forum 2025",
    },
    {
      type: "p",
      html:
        "The IGF will mark its 20th anniversary in Norway in June 2025. ICC will keep advocating for an open, secure, stable and inclusive Internet.",
    },
  ],
},

{
  slug: "icc-calls-for-continued-dialogue-on-biodiversity-benefit-sharing-mechanism",
  taxonomy: "Climate action",
  dateLabel: "3 November 2024",
  title: "ICC calls for continued dialogue on biodiversity benefit sharing mechanism",
  excerpt:
    "ICC has issued the following statement upon the conclusion of the United Nations’ Conference of the Parties to the Convention on Biological Diversity (CBD COP16) underscoring the commitment of business to support future efforts to secure a robust and workable multilateral benefit sharing mechanism.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/11/GettyImages-1405452705.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/11/GettyImages-1405452705.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "ICC appreciates the efforts of Parties and the Colombian Presidency at CBD COP16 to progress on the operationalisation of the multilateral mechanism on benefit sharing from the use of digital sequence information, including the COP16 Decision’s recognition that further work is needed to refine several of its elements .&nbsp;<br><br>Businesses are committed to supporting biodiversity goals and engaged constructively in the discussion – viewing the multilateral mechanism as an opportunity to increase benefits shared for biodiversity through a simpler system that provides more legal certainty for companies and supports research and innovation.",
    },
    {
      type: "quote",
      html:
        "As several countries have recognised, the decision provides a starting basis for moving forward but many important aspects require further evidence-based work to ensure that the mechanism has the necessary enabling conditions and incentives to engage broad business participation. A system that is broad in scope makes it easy to contribute, sets fees at realistic levels, provides legal certainty for research and innovation, and has the potential to incentivise more funding for biodiversity. Business will strengthen its engagement as an integral part of the solution and will need to play a role in further refining the mechanism to ensure its success.”",
    },
    {
      type: "p",
      html:
        "Further work could continue along several tracks, through formal CBD workstreams, informal dialogues, or a pilot phase to test the modalities in the decision and obtain evidence for consideration at COP17.&nbsp; ICC will be working with companies, countries and other stakeholders along all these tracks to optimise the potential of the mechanism to attract broad participation from businesses to further biodiversity goals. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
    },
  ],
},
{
  slug: "how-the-b20-is-turning-policy-into-action-for-a-sustainable-future",
  taxonomy: "Climate action",
  dateLabel: "29 October 2024",
  title: "How the B20 is turning policy into action for a sustainable future",
  excerpt:
    "Under the presidency of Brazil, this year’s Business 20 (B20) Summit took place in São Paulo on the 24th and 25th of October, bringing together over 1,000 business representatives for discussions under the theme “Inclusive Growth for a Sustainable Future”.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/10/GettyImages-582780650.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/10/GettyImages-582780650.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "As a B20 Network Partner, ICC supported the Brazilian National Confederation of Industry (CNI) in the fulfilment of the theme – contributing to the development of impactful policy recommendations, leveraging the participation of 11 ICC Executive Board members across a range of Task Forces, and ICC and World Chambers Federation leadership in the B20 International Business Advisory Caucus.",
    },
    {
      type: "p",
      html:
        "The B20 is a global platform for the international business community to support the work of the G20 process. Here’s how ICC is working to help the B20 turn policy into action.",
    },

    { type: "h2", text: "Improving representation of women in B20 Task Forces" },
    {
      type: "p",
      html:
        "As a partner institution of a new B20 initiative to help increase the representation of women in B20 membership and leadership, ICC pledged to support B20 presidencies by proposing women candidates eligible to chair B20 task forces and encouraging women to become B20 members through the mobilisation of the global ICC network in over 170 countries. The SheLeads B20 initiative aims to achieve 50% female representation by 2030. ICC Secretary General John W.H. Denton AO, who co-chaired a B20 Task Force on Finance and Infrastructure, signed the pledge on behalf of ICC, together with representatives from the OECD, Business at OECD, and International Organisation of Employers (IOE). Prominent women leaders, ICC Honorary Chair Maria Fernanda Garza, ICC Board Member Lama Al-Sulaiman and ICC World Chambers Federation First Vice-Chair Marie Christine Oghly co-chaired B20 Brazil Task Forces on Integrity and Compliance, Employment and Education, and Women, Diversity and Inclusion in Business respectively. Five additional female ICC Board Members (Candace Johnson, Rebecca Enonchong, Marienne Coutinho, Marjorie Yang, and Patricia Nzolantima) were also Members of B20 Task Forces this year.",
    },

    { type: "h2", text: "Women in trade" },
    {
      type: "p",
      html:
        "ICC is also a proud supporter of B20 Brazil’s Women in Trade legacy initiative. Working in collaboration with the International Trade Centre (ITC) and the Organisation for Economic Co-operation and Development (OECD), the initiative saw the G20 and B20 partner to share knowledge and best practices for inclusive trade policy designed to increase women’s participation in international trade.",
    },

    { type: "h2", text: "Combatting food loss and waste" },
    {
      type: "p",
      html:
        "The Summit also saw the launch of an ICC-B20 Global Challenge against Food Loss and Waste to address food insecurity. The Initiative aims to identify, through a global challenge, private sector projects that can contribute to tackle the most critical issues related to food loss and waste.",
    },
    {
      type: "p",
      html:
        "Following a consultation phase, businesses worldwide will be invited to submit proposals aimed at addressing the five biggest challenges related to food loss and waste. The highest-ranking projects will be presented at the FAO World Food Forum in October 2025, providing an opportunity for further visibility and engagement with key stakeholders. A founding member of the Global Alliance Against Hunger and Poverty, one of the Brazilian G20 Presidency’s key initiatives, ICC is committed to leveraging the unique expertise and network of the private sector to support and scale integrated solutions to sustainably and equitably feed the world.",
    },

    {
      type: "p",
      html:
        "Addressing B20 participants on a panel looking at how B20 Brazil legacy initiatives are turning policy into action, ICC Secretary General John W.H. Denton AO said:",
    },
    {
      type: "quote",
      html:
        "<strong>“Through the ICC-B20 Global Challenge against Food Loss and Waste, we aim to act as a bridge between the B20 and G20, ensuring public-private collaboration to achieve lasting solutions to poverty and hunger worldwide.”</strong>",
    },
  ],
},
{
  slug: "trade-finance-resilience-and-low-credit-risk-persist-amid-global-challenges-confirms-icc",
  taxonomy: "Banking and finance",
  dateLabel: "29 October 2024",
  title:
    "Trade finance resilience and low credit risk persist amid global challenges, confirms ICC",
  excerpt:
    "ICC 2024 Trade Register, with extended market insights, confirms resilience of trade finance and continued low credit risk.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/10/icc-stats-abstract-2.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/10/icc-stats-abstract-2.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "The International Chamber of Commerce (ICC), along with partners Global Credit Data (GCD) and Boston Consulting Group (BCG), has released its 2024 Trade Register Report, reaffirming the resilience of trade finance instruments and the continued low credit risk across products despite ongoing geopolitical and economic challenges .&nbsp;",
    },
    {
      type: "p",
      html:
        "The 2024 report confirms that trade, supply chain and export finance continue to exhibit low risk, with default rates remaining low across all regions and asset classes overall. When defaults do occur, they are generally idiosyncratic, stemming from well-known commercial, geopolitical or macroeconomic factors. As global trade faces ongoing geopolitical and economic pressures, these financial products continue to serve as vital tools for mitigating risk and maintaining liquidity, supporting the stability of trade flows.&nbsp;",
    },
    {
      type: "p",
      html:
        "The ICC Trade Register remains the leading, authoritative global source on credit risk and broader market dynamics in trade and supply chain finance. Its data set represents nearly a quarter of all global trade finance transactions. This 2024 edition includes extended market insights and data on global trade and trade finance. New features include insights from ICC and BCG’s practitioner survey on key trends and opportunities in trade and supply chain finance as well as a comprehensive data pack with analysis on credit risk in trade finance, available for member banks or for separate purchase through ICC.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "This year, ICC and GCD demonstrated the value of high-quality, representative data in shaping trade finance regulations through their contributions to emerging regulation on Basel III capital treatment. Krishan Ramadurai, outgoing Chair of the ICC Trade Register Project, encourages more banks to participate in the project and says that more data will only reinforce the point that trade finance is a low default asset class.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "The ICC Trade Register continues to look beyond credit risk, with detailed analysis on market trends and competitive dynamics across the trade and supply chain finance market.&nbsp;&nbsp;",
    },

    { type: "p", html: "Ravi Hanspal, Partner at BCG, said:&nbsp;" },
    {
      type: "quote",
      html:
        "<strong>“Despite ongoing headwinds, we are seeing the trade and supply chain finance market continue to evolve rapidly. Banks are observing that customers are now prioritising leading service and digital capabilities more than ever, driving a step-change in investment by banks in technology to accelerate seamless trade.”</strong>&nbsp;",
    },

    {
      type: "p",
      html:
        "Marilyn Blattner-Hoyle, Global Head of Trade Finance and Working Capital Solutions at Swiss Reinsurance Company, said: &nbsp;",
    },
    {
      type: "quote",
      html:
        "<strong>“ICC’s Trade Register and its deep data over many cycles is perhaps the most critical publication in the trade industry. The Register’s role in sharing quantitative and qualitative statistics underpins the power of trade as well as the stability of trade-related credit risks. It helps us to get comfortable insuring more trade with our bank clients, thus making trade and the world more resilient together. We use the Register in our actuarial assessments as well as our internal/external advocacy. We are proud to be the first insurance sponsor of the publication, affirming the important role of insurance in the global trade ecosystem.”</strong>&nbsp;",
    },

    {
      type: "p",
      html:
        "Christian Hausherr, Product Manager for SCF at Deutsche Bank and member of ICC Trade Register Steering Committee, said: &nbsp;",
    },
    {
      type: "quote",
      html:
        "<strong>“In its thirteenth year after being established, the ICC Trade Register proves its relevance and importance to the trade finance community. Since then, the data approach as well as the scope of the Trade Register have been materially enhanced by the team managing the publication process on an annual basis. As of today, the Trade Register offers unique insights not only into trade finance risk, but also provides valuable macro-economic insights to its readers.”</strong>&nbsp;",
    },

    {
      type: "p",
      html:
        "ICC Policy Manager Tomasch Kubiak thanks member banks for their ongoing contributions.<strong> </strong>",
    },
    {
      type: "quote",
      html:
        "<strong>“ICC is very appreciative of all the efforts member banks are putting in yet again for an enhanced version of the ICC Trade Register. This year’s project provides a full insight into meaningful trends in global trade finance as well as complete data collected from our members, which is now available on demand,”</strong> &nbsp;<br><cite>he said.</cite>",
    },

    {
      type: "contact",
      title:
        "For more information on the ICC Trade Register 2024, including any questions on participation and report pricing, please contact",
      contacts: [
        {
          name: "Tomasch Kubiak",
          job: "Policy Manager | Global Policy Team | Banking Commission",
          email: "tomasch.kubiak@iccwbo.org",
        },
        {
          name: "Andrew WILSON",
          job: "Deputy Secretary General – Policy",
          email: "andrew.wilson@iccwbo.org",
        },
      ],
    },

    {
      type: "p",
      html:
        '<a href="https://iccwbo.org/publication/icc-trade-register-report/" target="_blank" rel="noreferrer noopener">Read or purchase the full ICC Trade Register Report</a>.&nbsp;',
    },
  ],
},
{
  slug: "inflation-trade-uncertainty-and-labour-gaps-cloud-business-outlook-says-new-global-survey-of-chambers",
  taxonomy: "Chamber services",
  dateLabel: "16 October 2024",
  title:
    "Inflation, trade uncertainty and labour gaps cloud business outlook, says new global survey of chambers",
  excerpt:
    "Inflation, skilled labour shortages and trade uncertainties are weighing on the outlook for global business, according to a new survey of local business organisations in some 96 countries by the International Chamber of Commerce (ICC).",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/10/icc-global-market-trade-finance.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/10/icc-global-market-trade-finance.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "The findings of the global economic survey capture perspectives from businesses on key economic and sustainability issues across economies that collectively account for 90% of global GDP.&nbsp;&nbsp;&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Commenting at the launch of the survey results in Istanbul, ICC Secretary General John W.H Denton AO said:&nbsp;<strong> </strong>",
    },
    {
      type: "quote",
      html:
        "“As the voice of the real economy worldwide, ICC has leveraged its unique institutional reach to provide a comprehensive global picture of the realities of doing business in today’s increasingly complex environment. We hope this real-time data will help shape the strategic response of governments to the key challenges faced by MSMEs.”&nbsp;&nbsp;",
    },

    { type: "spacer", height: 10 },

    { type: "h3", text: "Global business environment&nbsp;&nbsp;" },
    {
      type: "p",
      html:
        "Rising prices and labour costs were cited as a significant challenge in the majority of countries surveyed, with more than 80% of respondents expressing concern that cost pressures will persist into 2025 — casting doubt on recent claims from prominent economists that inflation is “no longer a thing”.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Inflation has translated into significantly higher staffing costs for businesses in some 44 countries— a trend exacerbated in several regions by skills shortages in the local workforce, most notably North America and Europe.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "The economic environment and tight financial conditions have hindered access to finance where findings show that high interest rates are limiting access to credit particularly in Sub-Saharan Africa (80%), Latin America and the Caribbean (63%) and South Asia (60%).&nbsp;",
    },
    {
      type: "p",
      html:
        "Trade uncertainty was cited as a challenge by 50% of chamber respondents — with concerns highest in East Asia and Pacific (69%) the Middle East and North Africa (60%) and Latin America and the Caribbean (50%).&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Despite these challenges, the respondents in more than 50% of countries covered by the survey expressed cautious optimism for the outlook for business in their respective economies — suggesting a large degree of resilience in the face of economic and operational risk.&nbsp;&nbsp;",
    },
    { type: "p", html: "Mr Denton added:" },
    {
      type: "quote",
      html:
        "“Though headline rates of inflation have generally receded in recent months, the impact of the price surge seen from 2022 is clearly having a sustained impact on the private sector in many countries. We need policymakers to be sensitive to the disconnect between macroeconomic data and the day-to-day experience of local businesses.”&nbsp;",
    },

    { type: "spacer", height: 10 },

    { type: "h3", text: "Outlook on climate action&nbsp;&nbsp;" },
    {
      type: "p",
      html:
        "One month before the United Nations climate summit COP29, the survey also looked at the experience of small and medium-sized enterprises (SMEs) in transitioning to climate-friendly business models.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "In developing economies, chambers pointed to difficulties SMEs face in accessing clean sources of energy — both from national grids or decentralised generation.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "In advanced economies, SMEs are held back by a perceived lack of access to cutting-edge green technologies and limited in-house capacity to implement emissions reductions programmes.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "In both developed and developing economies, access to cost-effective finance to enable investments in decarbonisation was cited as a major challenge — pointing to the need for enhanced public support to enable SMEs to adopt green technologies and upgrade existing facilities.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html: "Rifat Hisarcıklıoğlu, Chair of the ICC World Chambers Federation added:",
    },
    {
      type: "quote",
      html:
        "“This survey highlights the crucial role chambers of commerce worldwide play as private sector champions. They are deeply in touch with the grassroots realities of doing business while maintaining a global perspective and remaining connected through our ICC World Chambers Federation.”&nbsp;&nbsp;",
    },

    {
      type: "button",
      text: "Read more and download the full report.",
      href:
        "https://iccwbo.org/news-publications/policies-reports/chamber-pulse-global-markets-local-landscapes/",
    },
  ],
},
{
  slug: "icc-institute-world-business-law-prize-open-for-applications",
  taxonomy: "Institute Prize",
  dateLabel: "11 September 2024",
  title: "ICC Institute World Business Law Prize open for applications",
  excerpt:
    "The International Chamber of Commerce (ICC) Institute of World Business Law has announced the launch of the 10th edition of the ICC Institute Prize. The award recognises excellent legal writing in the field of international commercial law and arbitration.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/09/institute-prize-business-law.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/09/institute-prize-business-law.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "Established in 2007, the Institute Prize encourages focused research on legal issues affecting international business. Contributing to the understanding and progress of international commercial law around the world, the award recognises legal writing excellence. Along with the recognition, laureates receive € 10,000 in prize money.&nbsp;",
    },
    {
      type: "p",
      html:
        'The ICC Institute Prize is open to anyone 40 years of age or under who submits a doctoral dissertation or long essay (minimum of 150 pages) drafted in French or English on international commercial law, including arbitration. The deadline for entries to the 10th edition is 7 April 2025. A special prizegiving ceremony will take place in Paris at the end of 2025 on the occasion of the ICC Institute of World Business Law annual conference. <a href="https://iccwbo.org/dispute-resolution/professional-development/icc-institute-of-world-business-law/institute-of-world-business-law-prize/" target="_blank" rel="noreferrer noopener">Find more information and the rules here.</a>&nbsp;',
    },
    {
      type: "p",
      html:
        "Last year’s winner, Sabrina Pearson-Wenger, received the Prize for her thesis on “Good Faith in International Commercial Arbitration: its Application by Arbitral Tribunals to the Parties’ Contract and the Arbitration Agreement”.&nbsp;",
    },
    {
      type: "p",
      html:
        '<a href="https://iccwbo.org/news-publications/news/icc-institute-prize-winner-announced/">The 2023 edition of the Institute Prize</a> saw 27 entries from nine countries, the second-highest number of entries ever received. All entries were carefully reviewed by an international jury comprising nine Council members of the ICC Institute. Given the significant number of submissions, 18 ICC Institute members assisted the jury in reading and evaluating the theses.&nbsp;',
    },
    {
      type: "p",
      html:
        "For the 2025 edition, the Jury will be chaired by ICC Institute Council member Winnie Ma, alongside Council members Mauricio Almeida Prado, Tolga Ayoğlu, Matthias Scherer, Joongi Kim, Cristina Martinetti, Stacie Strong, Habibatou Touré and Galina Zukova. Their diverse expertise will ensure a rigorous evaluation process, continuing the tradition established by previous juries.&nbsp;",
    },
    {
      type: "p",
      html:
        'This year’s ICC Institute of World Business Law Annual Conference will take place on 13 November 2024 on the topics of <a href="https://events2go.iccwbo.org/event/icc-institute-annual-conference" target="_blank" rel="noreferrer noopener">Res Judicata, Claim Preclusion, Issue Preclusion and Claim Splitting</a>.&nbsp;',
    },
  ],
},
{
  slug: "no-alternative-to-multilateralism-in-trade-says-icc-sg-at-g7",
  taxonomy: "Trade",
  dateLabel: "16 July 2024",
  title: "No alternative to multilateralism in trade says ICC SG at G7",
  excerpt:
    "The Secretary General of the International Chamber of Commerce has called on the world’s largest advanced economies to take meaningful steps to reform the World Trade Organization (WTO) ahead of a meeting of G7 trade ministers in Reggio Calabria, Italy.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/03/429889488_787180743449221_5312163257327952846_n.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/03/429889488_787180743449221_5312163257327952846_n.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "In a keynote speech at a special event hosted by the Italian G7 presidency in advance of the ministerial, John W.H. Denton highlighted the imperative for governments to strengthen the multilateral trading system amidst concerns of growing protectionism and simmering trade frictions.",
    },
    {
      type: "quote",
      html:
        "“We urge member states to put pragmatism in their discussions over politics and to pursue a holistic reform of the WTO to ensure that it continues to serve the needs of businesses – and the communities that they serve.”&nbsp;",
      cite: "ICC Secretary General John W.H. Denton AO",
    },
    {
      type: "p",
      html:
        "Mr Denton reiterated ICC’s concern at the steady erosion of the multilateral trading system over recent years – pointing to the major economic shock that any eventual collapse of the WTO system would precipitate.",
    },
    {
      type: "p",
      html:
        "“Let’s be clear: the demise of the rules based multilateral trading system will result in greater uncertainty and economic losses for all developing countries – including a 33% decline in global trade in goods, as well as permanent GDP loss of over 5%”, said Mr Denton, citing findings from ICC and Oxford Economics’ <a href=\"https://iccwbo.org/news-publications/policies-reports/study-shows-wto-collapse-could-slash-exports-of-developing-countries-by-33-percent/\">study</a> on the potential long-term structural impacts of WTO dissolution on developing economies.",
    },
    {
      type: "p",
      html:
        "The study showed that least developed economies would see export declines of 43% without the essential safety net provided by multilateral trade rules. The impacts of WTO dissolution would gradually intensify over time, with the full impact peaking by 2030 and remaining permanent.",
    },
    {
      type: "quote",
      html:
        "“We need action from governments, the WTO and the leadership of business, we want the bridge between developing and advancing economies to be maintained through the WTO,” added Mr Denton.",
    },
    {
      type: "p",
      html:
        "The Industry Stakeholders Conference is an official side event to the G7 Trade Ministerial meeting taking place on 17 July – organised in conjunction with the B7, the official platform for the international business community to support the work of the G7.",
    },
    {
      type: "p",
      html:
        "On the margins of the conference, Mr Denton also participated in a series of bilateral meetings with ministers and business leaders from across the G7 economies – as well as heads of several international organisations.",
    },
    {
      type: "p",
      html:
        "ICC is also a B20 Network Partner for the B20 Brazil 2024, the business platform to support the work of the G20.",
    },
  ],
},
{
  slug:
    "no-room-for-complacency-maritime-piracy-incidents-fall-but-crew-safety-remains-at-risk",
  taxonomy: "Trade",
  dateLabel: "11 July 2024",
  title:
    "No room for complacency: maritime piracy incidents fall but crew safety remains at risk",
  excerpt:
    "ICC’s International Maritime Bureau (IMB) is calling for sustained vigilance to protect seafarers amid increasing violence despite an overall drop in the number of incidents reported in its mid-year report for 2024, released today.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/07/GettyImages-1201905537.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/07/GettyImages-1201905537.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "Sixty incidents of piracy and armed robbery against ships were recorded in the first half of 2024, a decrease from 65 incidents for the same period in 2023.&nbsp;",
    },
    {
      type: "quote",
      html:
        "“While we are reassured to see a fall in the number of overall reported acts of piracy, the concerning rise in incidents of a violent nature underscores the need for continued vigilance from the international community to ensure the safety of all seafarers — especially at this time of heightened uncertainty for maritime transport.”&nbsp;",
      cite: "ICC Secretary General John W.H. Denton AO",
    },
    {
      type: "p",
      html:
        "Of the 60 incidents reported, 46 vessels were boarded, eight reported attempted attacks, four were hijacked and two were fired upon. Perpetrators successfully boarded 84% of targeted vessels.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Violence towards crew continues, with 85 taken hostage compared to 36 in the same period last year, 11 kidnapped and two threatened. Guns and knives were reported in 34 of the 60 incidents, a worrying increase from the same period last year.&nbsp;&nbsp;",
    },
    {
      type: "quote",
      html:
        "“While the decline in reported incidents is welcome, sustained and continued regional maritime cooperation remains essential to safeguard seafarers, global shipping and trade. There is no room for complacency.”",
      cite: "IMB Director Michael Howlett.",
    },

    { type: "h3", text: "Caution urged around Somali waters&nbsp;" },
    {
      type: "p",
      html:
        "Despite the decline in global reported incidents Somali piracy still poses a threat, with eight reported incidents in the first half of 2024, including three hijackings.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Recent incidents demonstrate the continued capability and capacity of the Somali pirates to target vessels up to 1,000 nautical miles (nm) off the Somali coast.&nbsp;",
    },
    {
      type: "p",
      html:
        "“We continue to urge caution around Somali piracy incidents and call on all vessel owners and Masters to harden their vessels and follow all recommended guidelines in the latest Best Management Practices while transiting Somali waters,” Mr Howlett said.&nbsp;&nbsp;",
    },

    { type: "h3", text: "Concern for crew in Gulf of Guinea&nbsp;" },
    {
      type: "p",
      html:
        "Incidents have dropped from 14 to 10 in the Gulf of Guinea but threats to crew safety and wellbeing continue to be a cause of concern.",
    },
    {
      type: "p",
      html:
        "The region accounts for the 11 crew kidnapped globally in the first half of 2024 in two separate incidents and 21 of the crew taken hostage in one incident.",
    },
    {
      type: "p",
      html:
        "IMB reiterates the need for a continued and robust regional and international naval presence to respond to these incidents and safeguard life at sea.",
    },

    { type: "h3", text: "Low reporting in Singapore Straits " },
    {
      type: "p",
      html:
        "There is a noticeable decrease of reported incidents in the Singapore Straits from 13 in the first half of 2024 compared to 20 the same period last year. However, the targeting and boarding of large vessels transiting through these waters remains worrying.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "While considered low-level opportunistic crimes, 10 crew were taken hostage in six separate incidents with guns and knives reported in 10 incidents.&nbsp;",
    },
    {
      type: "p",
      html: "Despite the decline of reported incidents, IMB is aware of incidents not being reported.&nbsp;&nbsp;",
    },

    {
      type: "h3",
      text: "Rising incidents in the Indonesian archipelagic region and Bangladesh",
    },
    {
      type: "p",
      html:
        "IMB has recorded 12 incidents in the Indonesian archipelago, the highest since the first half of 2020 when 15 incidents were reported.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Two crew were reported as taken hostage and one threatened during these incidents. Knives were reported in six incidents and guns in one incident. This year, six incidents occurred at Dumai anchorage compared to one in the first half of 2023.&nbsp;",
    },
    {
      type: "p",
      html:
        "Low-level incidents have increased in Bangladesh, up from one in the first six months of 2023 to ten in 2024. This is the highest reported number of incidents in the first half of a year since 2015. All vessels were at anchorage with nine incidents reported at Chattogram.&nbsp;",
    },
    {
      type: "p",
      html:
        'Download your copy of the 2024-January to June- Piracy and Armed Robbery Against Ships report <a href="https://www.icc-ccs.org/piracy-reporting-centre/request-piracy-report">here</a>.',
    },

    { type: "h3", text: "The IMB Piracy Reporting Centre" },
    {
      type: "p",
      html:
        "Since its founding in 1991, IMB’s Piracy Reporting Centre serves as a crucial, 24-hour point of contact to report crimes of piracy and lend support to ships under threat. Quick reactions and a focus on coordinating with response agencies, sending out warning broadcasts and email alerts to ships have all helped bolster security on the high seas. The data gathered by the Centre also provides key insights on the nature and state of modern piracy.&nbsp;",
    },
    {
      type: "p",
      html:
        "IMB encourages all shipmasters and owners to report all actual, attempted and suspected global piracy and armed robbery incidents to the Piracy Reporting Centre as a vital first step to ensuring adequate resources are allocated by authorities to tackle maritime piracy.&nbsp;&nbsp;",
    },
  ],
},
{
  slug: "inaugural-regional-summit-gets-underway-in-bogota",
  taxonomy: "World Chambers Federation",
  dateLabel: "8 May 2024",
  title: "Inaugural regional summit gets underway in Bogota",
  excerpt:
    "The ICC World Federation of Chambers (WCF) and the Bogotá Chamber of Commerce (CCB) is set to host the Summit of the Americas from 8-9 May 2024 in Bogotá.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/05/icc-bogota-view.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/05/icc-bogota-view.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        'This inaugural <a href="https://iccwbo.org/news-publications/news/regional-summits-to-intensify-chamber-impact/" target="_blank" rel="noreferrer noopener">WCF regional summit</a> will analyse market trends and international business opportunities in key sectors for MSMEs, through an academic and networking space that will promote trade and boost sales for entrepreneurs in Bogotá and the region.&nbsp;',
    },
    {
      type: "p",
      html:
        "Under the theme ‘Business Beyond Borders: MSMEs Going Global’, the summit will bring together representatives from more than 30 countries, 35 chambers of commerce, and 500 MSMEs as well as over 400 trading companies for two days of business learning and networking.&nbsp;&nbsp;",
    },
    { type: "p", html: "Chair of the ICC World Chambers Federation Rifat Hisarcıklıoğlu said:&nbsp;" },
    {
      type: "quote",
      html:
        "“We’re excited to launch our WCF regional summit series in Colombia, laying the groundwork for a global initiative that brings chambers together from across the world to foster collaborative endeavors aimed at enhancing business prosperity. As we look ahead, we eagerly anticipate welcoming numerous chambers from all around the world to our second edition in October, hosted by the Union of Chambers and Commodity Exchanges of Türkiye in Istanbul.”&nbsp;",
      strong: true,
    },
    {
      type: "p",
      html:
        "The agenda of the event will address topics of global interest ranging from leadership lessons for entrepreneurs from panels, keynote speeches and dynamic interviews analysing lessons learned from global leaders, best practices, challenges in regional value chains and the expansion of markets through empowerment, chamber relations and the cultural connection.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Ovidio Claros Polanco, president of the Bogotá Chamber of Commerce said:<strong>&nbsp;</strong>&nbsp;",
    },
    {
      type: "quote",
      html:
        "“From the Chamber of Commerce of Bogotá, we want to promote and make viable workspaces that allow the development of the businesses of MSMEs, in order to strengthen the popular economy. With this summit, we want to contribute to the expansion of markets and their businesses, promoting a connected and thriving business environment”.&nbsp;",
      strong: true,
    },
    {
      type: "p",
      html:
        "Aiming to approach global challenges and opportunities through a regional lens, the summit will also&nbsp; explore how digital tools, from technology optimisation to artificial intelligence, are transforming business. It will also examine how geopolitics and global supply chains in Latin America are essential in an interconnected world to support MSMEs, the backbone of the economy.&nbsp;",
    },
    { type: "p", html: "John W.H. Denton AO, Secretary General of the International Chamber of Commerce, said:&nbsp;&nbsp;" },
    {
      type: "quote",
      html:
        "“Enhancing the capacity of businesses to innovate, scale up, and generate opportunities for everyone, everywhere, our inaugural WCF Regional Summit will be a catalyst for chambers and businesses in Latin America to bolster trade and strengthen international cooperation. In turn, the real economy issues and barriers discussed at the Summit will inform our work at the global level as the most inclusive business network in the world”.&nbsp;",
      strong: true,
    },
    {
      type: "p",
      html:
        "In addition to Mr Denton, headline speakers attending the Summit of the Americas are María Fernanda Garza, Chair of the International Chamber of Commerce; Toki Mabogunje, Vice-President for Africa of the ICC World Federation of Chambers; Richard Ngatia, President of the East African Chamber of Commerce, Industry and Agriculture; Hassan Al Hashemi, Vice-President of International Relations, Dubai Chamber; Marcelo Elizondo, Director of the Argentine Chamber of Commerce; Maria Teresa Bustamante, President of the Brazilian Chamber of Commerce and Federation of Industries; Shannon K. O’Neill, Vice-President of the Council on Foreign Relations; and Andrés Moreno, Founder, Chairman of the Board of Directors, and CEO of Open English.&nbsp;",
    },
    {
      type: "p",
      html:
        '<a href="https://iccwbo.org/world-chambers-federation/chamber-services/icc-world-chambers-federation-regional-summits/" target="_blank" rel="noreferrer noopener">Learn more about WCF regional summits</a>&nbsp;',
    },
  ],
},
{
  slug: "applications-now-open-for-startup-awards",
  taxonomy: "SME and entrepreneurship",
  dateLabel: "7 May 2024",
  title: "Applications now open for startup awards",
  excerpt:
    "Applications are now open until 31 August for the second edition of the Startup Ecosystem Stars (SES) Award Ceremony set to take place on 4 December 2024 in Paris.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/05/pexels-dana-tentis-118658-370799.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/05/pexels-dana-tentis-118658-370799.jpg?w=1080&h=1200&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        'Co-organized by ICC and <a href="https://mindthebridge.com/" target="_blank" rel="noreferrer noopener">Mind the Bridge</a> (MTB), in collaboration with the <a href="https://www.oecd.org/" target="_blank" rel="noreferrer noopener">OECD</a> and the <a href="https://commission.europa.eu/index_it" target="_blank" rel="noreferrer noopener">European Commission</a>, and with support from <a href="https://www.microsoft.com/it-it" target="_blank" rel="noreferrer noopener">Microsoft</a>, the SES Awards recognise excellence among organisations fostering innovation in their ecosystems in addition to showcasing success stories, promoting collaboration and stimulating opportunities for innovation ecosystem growth.&nbsp;',
    },
    {
      type: "quote",
      html:
        "“<em>Innovation ecosystems play a pivotal and vital role in supporting entrepreneurship and advancing global goals. We at ICC believe that demonstrating leadership within these ecosystems not only enables businesses to thrive but also drives more opportunities built on a shared purpose for a brighter future for all.</em>”",
      cite:
        "Candace Johnson, ICC Executive Board Member, Vice-Chair of the ICC Policy Committee and Chair of the Awards Jury.",
    },
    {
      type: "p",
      html:
        "Last year, former EU Commissioner Mariya Gabriel received special recognition as “Person of the Year”, acknowledging her significant contribution in fostering innovative ecosystems in Europe and beyond. In addition, 15 regions and cities across four categories from 10 countries and five continents were recognised as “Startup Ecosystem Stars”.&nbsp;",
    },
    {
      type: "quote",
      html:
        "“<em>The SES Awards are built upon a decade-long research and experience in tracking and benchmarking innovation ecosystems worldwide. This initiative uses the MiTB ‘Innovation Ecosystem Life Cycle Model’ to make international comparisons, estimate growth trajectories, and highlight factors behind different growth paces,</em>”",
      cite:
        "<em>said <strong>Alberto Onetti and Marco Marinucci</strong>, respectively Chairman and CEO of Mind the Bridge.&nbsp;&nbsp;</em>",
    },
    {
      type: "p",
      html:
        "The SES Awards follow an open call application process, targeting programmes and initiatives able to boost the development of innovation ecosystems. Candidate organisations can be public or private organisations, or agencies representing cities, regions, countries, or supranational entities that have a direct impact on their respective innovation ecosystems.&nbsp;",
    },
    {
      type: "p",
      html:
        "To be eligible, organisations and agencies are required to run excellent programmes in one of the following five categories: Best-in-class Startup Programs, Outstanding Investment Boost, Visionary Public Procurement, Top Talent and Research, and Exceptional Industry Support.&nbsp;",
    },
    { type: "p", html: "Initiatives are evaluated based on criteria such as programme novelty, impact and efficacy.&nbsp;" },
    { type: "p", html: "A distinguished jury, led by Candace Johnson, Serial Entrepreneur and ICC Executive Board member, evaluates applications.&nbsp;" },
    { type: "p", html: "Winning organisations will be invited to attend the official Award Ceremony event at ICC Global Headquarters in Paris in December.&nbsp;&nbsp;" },
    {
      type: "p",
      html:
        'Submit <a href="https://mindthebridge.typeform.com/ses-2024">your application</a>.',
    },
  ],
},
{
  slug: "saudi-arabia-and-the-philippines-to-launch-ata-operations-in-2024",
  taxonomy: "ATA Carnet",
  dateLabel: "22 April 2024",
  title: "Saudi Arabia and the Philippines to launch ATA operations in 2024",
  excerpt:
    "The International Chamber of Commerce (ICC) will welcome the Kingdom of Saudi Arabia and the Republic of the Philippines as part of its ATA Carnet International Guaranteeing Chain (ATA Chain). The ATA Carnet is an international customs document operated since 1963 that allows duty- and tax-free temporary admission of goods for up to one year.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2021/09/icc-world-trade-business-transport.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2021/09/icc-world-trade-business-transport.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "The implementation of ATA Carnets will be effective on 1 June 2024 for the Kingdom of Saudi Arabia and on 15 July 2024 for the Republic of the Philippines, making the ATA Carnet procedure operational in 81 countries/customs territories.&nbsp;",
    },
    {
      type: "p",
      html:
        "The Federation of Saudi Chambers and the Philippines Chamber of Commerce and Industry, as national guaranteeing and issuing associations were approved during a meeting of the ICC World Chambers Federation (WCF) General Council on 21 November 2023.&nbsp;&nbsp;&nbsp;",
    },
    { type: "p", html: "Julian Kassum, ICC WCF Director said:" },
    {
      type: "quote",
      html:
        "<em>“</em>Building on several years of preparatory work with the public and private sector in both countries, we are thrilled to establish the ATA Chain in Saudi Arabia and the Philippines in 2024. This is a significant achievement for the business community. We are convinced that businesses and traders will find it much easier to do business with Saudi and Filipino partners with the help of ATA Carnets, enhancing the international competitiveness of the markets and local products of the two countries.”&nbsp;&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "As of 1 June 2024, Saudi Customs will start accepting ATA Carnets for goods for display or use at exhibitions, fairs, meetings or similar events (Annex B1 of the Istanbul Convention).&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "The scope of application of the ATA Carnet procedure in the Philippines starting 15 July 2024 will cover exhibitions, professional equipment, commercial samples, goods in connection with a manufacturing operation, goods for educational, scientific or cultural purposes, travellers’ personal effects and goods for sports purpose, goods for humanitarian purposes, and even animals.&nbsp;&nbsp;",
    },
    { type: "p", html: "Henk Wit, Chair of the World ATA Carnet Council (WATAC) said:" },
    {
      type: "quote",
      html:
        "“Having the Federation of Saudi Chambers join the ATA Chain offers considerable advantages for ATA users, especially the exhibition and event industry. We are convinced that the ATA Carnet will play a crucial role in the country’s international development, especially since they will be hosting the World Expo in Riyadh in 2030.”&nbsp;&nbsp;",
    },
    { type: "p", html: "In regards to the Philippines, Mr Wit welcomed the wide scope of application and said that" },
    {
      type: "quote",
      html:
        "“the flexibility would certainly be appreciated by the international community and would greatly help the country to attract foreign investors and visitors.”&nbsp;",
    },
    {
      type: "p",
      html:
        "Also known as the ‘passport for goods’, ATA Carnets are internationally recognised custom documents&nbsp;that allow the duty- and tax-free temporary import of goods for up to one year.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "The ATA Chain is a guaranteeing mechanism administered by the ICC World Chambers Federation (WCF). ATA Carnets are issued at national level by National Guaranteeing Associations (NGAs).&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "With less than 100 days to go to the 2024 Paris Olympic and Paralympic Games, thousands of athletes, media representatives and suppliers are preparing their trip to France this summer. The ATA Carnet is a vital tool to bring their broadcasting, sports and other professional equipment across borders – free of duties and taxes – for use at the Games.&nbsp;",
    },
    {
      type: "figure",
      html:
        '<figure class="wp-block-image aligncenter size-large is-resized"><a href="https://www.linkedin.com/posts/international-chamber-of-commerce_paris2024-atacarnet-paris2024-activity-7186340157694910464-5K9s?utm_source=share&amp;utm_medium=member_desktop"><img fetchpriority="high" decoding="async" src="https://iccwbo.org/wp-content/uploads/sites/3/2024/04/icc-linkedin-post-ata-carnet.png?w=454" alt="" class="wp-image-519762" width="227" height="387" srcset="https://iccwbo.org/wp-content/uploads/sites/3/2024/04/icc-linkedin-post-ata-carnet.png 454w, https://iccwbo.org/wp-content/uploads/sites/3/2024/04/icc-linkedin-post-ata-carnet.png?resize=176,300 176w, https://iccwbo.org/wp-content/uploads/sites/3/2024/04/icc-linkedin-post-ata-carnet.png?resize=110,187 110w, https://iccwbo.org/wp-content/uploads/sites/3/2024/04/icc-linkedin-post-ata-carnet.png?resize=220,375 220w" sizes="(max-width: 227px) 100vw, 227px"></a></figure>',
    },
    {
      type: "button",
      text: "More information about ATA Carnet",
      href: "https://iccwbo.org/business-solutions/ata-carnet/",
    },
  ],
},
{
  slug: "new-icc-hearing-centre-unveiled",
  taxonomy: "Dispute Resolution Services",
  dateLabel: "18 March 2024",
  title: "New ICC Hearing Centre unveiled",
  excerpt:
    "ICC has announced details on the opening of an ICC Hearing Centre in Paris, including its location, set-up and expected opening date.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/03/icc-new-hearing-center-news.png?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/03/icc-new-hearing-center-news.png?w=1080&h=1032&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "contact",
      title:
        "For more information on the new the ICC Hearing Centre contact:",
      contacts: [
        {
          name: "Fiona Dermody",
          job: "ICC Hearing Centre Manager",
          email: "fiona.dermody@iccwbo.org",
        },
      ],
    },
    {
      type: "p",
      html:
        "Located in a serene area of the 17<sup>th</sup> <em>arrondissement</em>, the ICC Hearing Centre is being constructed on <em>Rue Legendre</em>, just minutes away from major Paris law firms and the <em>Cité judiciaire</em>, and conveniently accessible from the city’s train stations and airports.",
    },
    {
      type: "p",
      html:
        "The ICC Hearing Centre will span across a single level and offer two sets of hearing and breakout rooms, with the possibility of extending to a third to manage overflow. The state-of-the-art premises have been designed to provide premium service for in-person, hybrid and virtual hearings in terms of efficiency, technology, confidentiality, accessibility and overall comfort.",
    },
    {
      type: "p",
      html:
        "The property housing the ICC Hearing Centre will include a five-star boutique hotel, a restaurant, café, fitness centre, roof terraces, as well as other office spaces. It is being developed by <a href=\"https://www.groupegalia.com/\" target=\"_blank\" rel=\"noreferrer noopener\">Groupe Galia</a>.",
    },
    {
      type: "p",
      html:
        "<em>Alexander G. Fessas, Secretary General of the ICC International Court of Arbitration and Director of ICC Dispute Resolution Services</em> said:",
    },
    {
      type: "quote",
      html:
        "Providing excellent service to all arbitration and ADR hearings out of Paris, regardless of their institutional setting, has long been our objective, and we are delighted that the perfect home for our new Hearing Centre is now being constructed. We cannot wait to welcome our guests back in the autumn of 2024.",
      author:
        "Alexander G. Fessas, Secretary General of the ICC International Court of Arbitration",
    },
  ],
},
  {
    slug: "law-society-of-ireland-wins-2024-icc-mediation-competition",
    taxonomy: "Mediation",
    dateLabel: "12 February 2024",
    title: "Law Society of Ireland wins 2024 ICC Mediation Competition",
    excerpt:
      "The Law Society of Ireland team took first place in the 19th ICC International Commercial Mediation Competition, defeating a team from Germany’s University of Marburg during the final mediation session. Vrije Universiteit Amsterdam from The Netherlands and the National University of Singapore were competition runner ups.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2024/02/icc-mediation-competition-2024-2-e1707755940682.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2024/02/icc-mediation-competition-2024-2-e1707755940682.jpg?w=1080&h=603&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "p",
        html:
          "The Competition final, held in the historical Émile Boutmy Lecture Hall of Sciences Po University in Paris saw student teams face a mock mediation problem featuring damaged trams. It was written by professor Greg Bond, mediator at bond &amp; bond, and mediated by independent Hong Kong mediator Jody Sin.",
      },
      {
        type: "p",
        html:
          "The Competition marked the first final for an Irish team and the first final for competition regulars, the University of Marburg. Aoife O’Carroll and Eoin Doyle represented Law Society of Ireland on stage, while teammate Clíodhna McHugh supported from the audience.",
      },
      { type: "p", html: "Ms O’Carroll said:" },
      {
        type: "quote",
        html:
          "We are very happy and proud of our win. We entered the competition with zero expectations as we had never participated in a mediation session before. The competition was a learning curve for us, I think one can see the progress we have made if you compare our first session to the one today. During each round, we learned from gaining experience, but also from seeing the other teams perform. The Mediation Competition is so international and it was interesting to get to know the angles from other cultures. I think I can speak for the three of us that this week has planted a seed of passion for mediation inside us and we will certainly further look into it. More than ever, we believe mediation is the future.",
        author: "Ms O’Carroll",
      },
      {
        type: "p",
        html:
          "The ICC Mediation Competition is one of the biggest educational competitions worldwide dedicated exclusively to international commercial mediation. Hosted in Paris from 5 to 10 February, 46 university teams from 31 countries competed to resolve international business disputes through mediation. Guided by professional mediators and administered under the ICC Mediation Rules, over 75 mock mediation sessions took place. In total, this 19th edition gathered over 300 students and professionals.",
      },
      {
        type: "p",
        html:
          "Mediation professional Kimberly Schreiber took part in the ICC Mediation Competition for the 13th year, this time serving as one of the five judges during the final. Commenting on the competition, she said:",
      },
      {
        type: "quote",
        html:
          "2024 was again a fantastic edition. I have been here so many times now and I am still amazed by the level of excellence and the huge amount of preparation by the students. This is the biggest mediation competition of the year and I believe we are shaping future mediation leaders here today. The final was very enjoyable and realistic. It was a tight decision, in some aspects, one team was a bit better, but in other aspects the other team was. In the end, I think Ireland deserves the win.",
        author: "Kimberly Schreiber",
      },
      {
        type: "p",
        html:
          "The trophy was awarded by ICC International Court of Arbitration Secretary General and ICC Dispute Resolution Services Director Alexander G. Fessas. He said:",
      },
      {
        type: "quote",
        html:
          "Corporates, states, and state-owned entities do not litigate, arbitrate or mediate because they like doing it; they do it because they want a solution. They are tools in the toolbox to make businesses work. The Mediation Week is such an important event for ICC, because it is greatly educational, allowing the practitioners of tomorrow to understand how businesses can go back to the business of doing business.",
        author: "Alexander G. Fessas",
      },
      { type: "p", html: "University of Marburg Team member Klara Zimmerman said:" },
      {
        type: "quote",
        html:
          "This has been a very fun week. Even during the final, we enjoyed every moment. It is a pity we just missed first place, but Ireland deserved the win. For us, the journey was the most important anyway. During the past week, we have learned a lot and met so many incredible people that the 2024 Mediation Competition will be something we will remember forever.",
        author: "Klara Zimmerman",
      },
      {
        type: "p",
        html:
          "Relive all the highlights of the ICC Mediation Competition on <a href=\"https://twitter.com/ICCMediation\" target=\"_blank\" rel=\"noreferrer noopener\">X</a> and <a href=\"https://www.facebook.com/ICCmediation\" target=\"_blank\" rel=\"noreferrer noopener\">Facebook</a> by following the official event hashtag, #ICCMW2024. A recording of the final session is also available on the ICC Official YouTube channel <a href=\"https://www.youtube.com/watch?v=3fgbknm-5RY\" target=\"_blank\" rel=\"noreferrer noopener\">@ICCWBO1919</a>.",
      },
      {
        type: "p",
        html:
          "For more information on ICC mediation services, visit the <a href=\"https://iccwbo.org/contact-us/dispute-resolution-services-contact-us/#anchor-contact-the-international-centre-for-adr\" target=\"_blank\" rel=\"noreferrer noopener\">ICC International Centre for ADR</a>.",
      },
    ],
  },

  {
    slug: "clock-is-ticking-for-future-of-e-commerce-and-digital-trade",
    taxonomy: "Trade",
    dateLabel: "24 January 2024",
    title: "Clock is ticking for future of e-commerce and digital trade",
    excerpt:
      "A World Trade Organization (WTO) moratorium on customs duties on electronic transmissions is set to expire in February. Without its renewal, the future of e-commerce and digital trade hangs in the balance.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2023/02/icc-TradeFlow-Management.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2023/02/icc-TradeFlow-Management.jpg?w=1080&h=840&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "p",
        html:
          "The WTO E-Commerce Moratorium will lapse unless WTO members agree to renew it at the WTO’s upcoming 13<sup>th</sup> Ministerial Conference, which is set to take place next month on 26-29 February in Abu Dhabi. ICC is calling on all WTO members to renew the agreement and has been making the case for its permanent adoption.",
      },
      {
        type: "p",
        html:
          "Without an extension, governments could start to experiment with unilateral tariffs on everything from software, digital payments, and cloud services to the data supporting popular streaming services, disrupting the digital economy and driving up the cost of digital services that businesses across the world depend on to run and grow their operations.",
      },
      { type: "p", html: "ICC Secretary General John W.H. Denton AO said:" },
      {
        type: "quote",
        html:
          "The Moratorium is a critical safeguard and allowing it to lapse would be a historical setback, hurting small businesses and consumers the most, driving up costs and reducing access to knowledge, information, and digital tools. Not only would such a move add to a damaging pattern of escalating tariffs; it would also wreak potential havoc on the online economy. Tariffs really could ‘break the Internet’.",
        author: "John W.H. Denton AO",
      },
      {
        type: "p",
        html:
          "The Moratorium has been in place since the WTO’s Second Ministerial Conference in 1998. Since then, governments have agreed to extend it at the biennial WTO Ministerial Conference.",
      },
      {
        type: "p",
        html:
          "While lacking a specific definition, the term “electronic transmissions” is generally understood to mean anything from software to digital music, movies, and video games. The moratorium has played an important role in the development of the Internet by keeping tariffs off digitally delivered products, services and content.",
      },
      {
        type: "quote",
        html:
          "The agreement has played a hidden – but vital – role in the growth of the Internet economy over the past two decades shielding the Internet from distortions and disruptions induced by levies at national borders. We urge governments to ensure that the moratorium is renewed at MC13 next month,",
        author: "Mr Denton",
      },
      {
        type: "p",
        html:
          "said Mr Denton.",
      },
      {
        type: "p",
        html:
          "<strong>Read more about the WTO E-Commerce Moratorium </strong><a href=\"https://intracen.org/file/2023icc-itc-joint-icc-itc-policy-brief-edition-1-wto-moratoriumpdf\"><strong>here</strong></a><strong>.</strong>",
      },
    ],
  },

  {
    slug: "mexican-small-business-entrepreneur-shows-how-sustainability-reporting-tool-fits-the-bill",
    taxonomy: "SME and entrepreneurship",
    dateLabel: "21 December 2023",
    title:
      "Mexican small business entrepreneur shows how sustainability reporting tool fits the bill",
    excerpt:
      "The demand for measuring the environmental impact of SMEs is growing, and so is the need for SMEs to go green. With the assessment tool SME360X and supporting initiatives like the UPS Green Exporters Program, ICC, Gist Impact and UPS aim to make sustainable business a reality for all. In this series, we share stories of SMEs, like Mexican artisan textile business Marieta Linda, as they champion the green transition in their day-to-day business.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/Marieta-Linda2.png?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/Marieta-Linda2.png?w=1068&h=612&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "p",
        html:
          "Based in Villa Victoria, Mexico, <a href=\"https://www.facebook.com/Marietalindamx/about\">Marieta Linda</a> is a business dedicated to the sale and distribution of hand-embroidered textile accessories for pets and people. The company is inspired by the colours, traditions, creativity and quality of Mexican master artisans, and is dedicated to preserving these traditions through their accessories. All of their products are hand-embroidered by Mazahua women, one of the most representative indigenous groups in the State of Mexico. The business collaborates directly with the community of artisans, without intermediaries, to help distribute their products, working through fair trade.",
      },
      {
        type: "p",
        html:
          "Maria del Carmen Hernández Córdova, who founded Marieta Linda in 2019, saw the negative impacts the textile industry was having on the planet, and wanted to ensure her business was doing as much as possible to operate more sustainably. “For me, it was very important from the beginning not only to consider the development of our suppliers, but also to join in on this movement which I see as no longer optional,” Maria said. “I wanted to do as much as possible to reduce the impact we’re having on our planet, especially knowing that the textile industry is one of the most polluting industries.”",
      },
      {
        type: "p",
        html:
          "With this in mind, the Marieta Linda team looked at various options to help with evaluating her business’ environmental impacts, and was introduced to <a href=\"https://iccwbo.org/business-solutions/services-for-small-business-and-entrepreneurship/discover-sme360x/\">SME360X</a> through the Mexican Entrepreneurship Institute. “For me it was incredible to be able to use it and see that we all have access to it.”",
      },
      {
        type: "figure",
        src: "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/MarietaLinda5.png",
        alt: "",
        caption:
          "Maria del Carmen Hernández Córdova, who founded Marieta Linda in 2019, saw the negative impacts the textile industry was having on the planet, and wanted to ensure her business was doing as much as possible to operate more sustainably.",
      },
      { type: "h3", html: "Learnings from SME360X" },
      {
        type: "p",
        html:
          "When Maria first started using SME360X, she was struck by the insights she was able to access via the platform. It was the business’ electricity and waste impacts that caught her attention first.",
      },
      {
        type: "p",
        html:
          "“Having used the tool, it was interesting for us to be able to discover that, although we are a micro-business and the operation is very small, we can also mitigate the environmental impact in a certain way,” Maria said. “I thought: how can we reduce these impacts and manage them? The textile industry is unfortunately one of the most polluting, and so we looked at the energy and waste in all of our products and acted to make sure the amount of fabric we were wasting was minimal.”",
      },
      {
        type: "p",
        html:
          "Informed by the insights generated from the SME360X assessment process, the Marieta Linda team turned their focus to the water treatment of its garments as well as the packaging materials, reducing their use of plastics, and altering delivery methods where possible. They also started to reassess the suppliers they were working with.",
      },
      {
        type: "p",
        html:
          "“In the case of packaging, we are looking at suppliers that have a smaller impact now and working with those who can meet the requirements that we are requesting. We have tried to reduce [our impacts] … In some cases, it is feasible for us to make the delivery ourselves so that we don’t have to use Styrofoam and other less sustainable materials that we sometimes request in parcels. And we are also looking for elements we can use that cause the least pollution.”",
      },
      {
        type: "p",
        html:
          "The educational elements of the SME360X platform also helped her build a better understanding of environmental data and impact assessment best practices. “The platform is really a great ally in terms of training… [it is] helping us to strengthen the day-to-day activities of Marieta Linda,” Maria said.",
      },
      {
        type: "p",
        html:
          "“Unfortunately, as entrepreneurs or even as micro-entrepreneurs, we often don’t know what the regulations are, and we go for the most common options. “For example, I’m in the textile industry, so I just follow the labelling rules. But little by little we are professionalising our services, and getting to know more about the environment, and in the process, we are also discovering some other needs and points of improvement that are within these rules.”",
      },
      {
        type: "figure",
        src: "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/Marieta-Linda2.png",
        alt: "",
        caption:
          "Informed by the insights generated from the SME360X assessment process, the Marieta Linda team turned their focus to the water treatment of its garments as well as the packaging materials, reducing their use of plastics, and altering delivery methods where possible.",
      },
      { type: "h3", html: "Recognising no business is an island" },
      {
        type: "p",
        html:
          "The tool means the Marieta Linda team now has an environmental strategy in place and targets set for 2024. Maria recognises that this process is a marathon, not a sprint, but she’s confident that they’re taking steps in the right direction. “The marathon now has a focus to it, meaning we can see where we have succeeded and maybe we can incorporate some other improvement areas into it.”",
      },
      {
        type: "p",
        html:
          "Maria notes that the tool is “great for learning”, and that it has helped her see that if entrepreneurs like her can join in the efforts to lower their emissions, then this can have a global impact.",
      },
      {
        type: "p",
        html:
          "“Don’t be afraid, sometimes we think that small things have no impact on the environment, but remember that everything adds up and makes a difference,” Maria said. “There are so many grains of sand but eventually they become granite, they become beaches. We should not just be thinking about ourselves and minimising the result of our efforts, but on the contrary, joining together to really be able to have a global impact.”",
      },
    ],
  },

  {
    slug: "guest-blog-how-will-ai-impact-dispute-resolution",
    taxonomy: "Dispute Resolution Services",
    dateLabel: "19 December 2023",
    title: "Guest blog: How will AI impact dispute resolution?",
    excerpt:
      "In this guest blog, FTI Consulting Senior Managing Directors Samuel Aguirre, Leonardo Florencio and Karthik Balisagar explore the transformative potential of artificial intelligence (AI) in the legal industry. Revealing insights from a comprehensive survey of over 100 legal practitioners worldwide, the authors explore the current landscape, challenges, and the slow adoption of AI in dispute resolution. With a focus on bridging the knowledge gap and establishing clear guidelines, they shed light on concerns, but also significant benefits AI adoption could bring.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/icc-ia-impact.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/icc-ia-impact.jpg?w=1080&h=1095&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "p",
        html:
          "In a recent legal case, <a href=\"https://www.forbes.com/sites/mollybohannon/2023/06/08/lawyer-used-chatgpt-in-court-and-cited-fake-cases-a-judge-is-considering-sanctions/?sh=64e3d38a7c7f\" target=\"_blank\" rel=\"noreferrer noopener\">lawyers used ChatGPT</a> to prepare their arguments. It cited cases that were completely fictitious, no doubt causing those lawyers a great deal of embarrassment. But the game-changing potential of properly implemented AI technology – namely, its ability to process unlimited amounts of data and render outcomes that are unencumbered by human emotion – may be transformative for the entire legal industry. Law firms that can achieve advanced levels of AI competency will enjoy a massive competitive advantage in the decades to come.",
      },
      {
        type: "p",
        html:
          "FTI Consulting <a href=\"https://www.fticonsulting.com/insights/reports/power-ai-navigating-paradigm-shift-dispute-resolution-services\" target=\"_blank\" rel=\"noreferrer noopener\">conducted an online survey</a> of more than 100 lawyers, arbitrators, mediators and other legal practitioners worldwide from firms of all sizes, asking them for their opinions about the use of AI in the dispute resolution industry.",
      },
      {
        type: "p",
        html:
          "There are few outright objections to the use of AI in the legal community. While the potential applications of AI in dispute resolution services are extensive, there are also challenges. If the concerns about AI tools are left unaddressed, the use of AI may be relegated to basic tasks, and legal practitioners may miss opportunities to develop more meaningful applications that can significantly enhance their practice.",
      },
      {
        type: "p",
        html:
          "Despite the ubiquity of AI in the news, the survey indicates that lawyers are generally unfamiliar with AI tools. The greater the unfamiliarity, the greater concerns they have about the accuracy and consistency of outcomes and overreliance on the technology. Yet, while many respondents expected the use of AI to increase over the next three years, few are planning any substantial investments in the technology.",
      },

      { type: "h2", html: "How is AI being used today in dispute resolution?" },
      {
        type: "p",
        html:
          "As in other industries, the implementation of AI in legal services presents a significant opportunity for practitioners, with the potential to revolutionise the disputes industry and transform the way legal and expert services are delivered. But the adoption of AI-powered tools in dispute resolution services is slow and not without its challenges.",
      },
      {
        type: "p",
        html:
          "The survey findings reveal that AI-powered tools currently are not widely prevalent in dispute resolution. Currently, e-discovery and document review and drafting are the most popular areas to apply AI. Only a few practitioners say their firms explored the use of AI in other more complex use cases, such as predictive case outcomes, legal research or drafting deposition questions.",
      },
      {
        type: "p",
        html:
          "Only one-third of those surveyed say their firms have clear guidance for the use of AI in disputes, with larger firms leading the way in establishing clear guidelines and frameworks. Additionally, 23% claim they do not have any guidelines or frameworks when it comes to the use of AI in their dispute practice, and another 25% say the existing guidelines and frameworks are not clear.",
      },

      { type: "h2", html: "How can we speed up AI adoption in the dispute resolution industry?" },
      {
        type: "p",
        html:
          "Legal practitioners tend to agree that AI-powered tools can enhance the credibility and persuasiveness of legal arguments in disputes, a sentiment widely shared among those with more advanced or intermediate knowledge of AI technology.",
      },
      {
        type: "p",
        html:
          "This optimism in AI is also echoed in future applications of the technology, with 64% of legal practitioners saying they believe that three years from now AI will revolutionise the disputes industry and transform the way legal and expert services are delivered. Similarly, those who are more knowledgeable about AI are more likely to agree with the statement, as well as feel more strongly about it.",
      },
      {
        type: "p",
        html:
          "Confidence levels and perceptions of AI technology are closely tied to knowledge and practical experience, emphasising the need for bridging the knowledge gap in the legal profession. Legal practitioners who self-identify as advanced/intermediate and those whose firms have used AI in disputes in the past rate their confidence levels significantly higher than their counterparts with less experience. Greater knowledge and exposure to AI technologies can help boost practitioner confidence levels and help integrate AI solutions more successfully. In short, to capture the full potential of AI, legal practitioners will need to bridge the educational gap and law firms will need to set clear guidelines on the use of the technology.",
      },

      { type: "h2", html: "Who benefits from AI in dispute resolution?" },
      {
        type: "p",
        html:
          "One-third of legal practitioners believe AI has significant potential to improve access to justice. Those with more knowledge and exposure to AI through their firms have a significantly higher perception of the potential of AI, suggesting that a more advanced understanding and exposure to technology correlates with a greater sense of optimism around the transformative impact of AI on access to justice.",
      },
      {
        type: "p",
        html:
          "Surveyed practitioners believe law firms stand to benefit the most from the use of AI in dispute resolution, followed by parties belonging to the dispute and in-house legal departments. Practitioners with advanced/intermediate knowledge compared to those with beginner or less knowledge are significantly more likely to recognise AI benefits to their firms compared to their less experienced counterparts (90% vs. 66%). Also, firms with experience using AI in disputes are similarly more likely to recognise these benefits compared to firms that haven’t used AI (90% vs. 70%).",
      },
      {
        type: "p",
        html:
          "Practitioners whose companies have used AI in disputes in the past are more likely to recognise its multiple benefits, especially in handling large quantities of information (85% vs. 57%) and automation of manual processes (54% vs. 20%), compared with those who haven’t.",
      },
      {
        type: "p",
        html:
          "<em>Disclaimer: The views expressed herein are those of the author(s) and not necessarily the views of FTI Consulting, Inc., its management, its subsidiaries, its affiliates, or its other professionals. Similarly, the content of this article does not reflect the official views of the International Chamber of Commerce.</em>",
      },
      {
        type: "p",
        html:
          "<em>FTI Consulting, Inc., including its subsidiaries and affiliates, is a consulting firm and is not a certified public accounting firm or a law firm. </em><em>©2023 FTI Consulting, Inc. All rights reserved. </em><a href=\"https://urldefense.proofpoint.com/v2/url?u=http-3A__www.fticonsulting.com&amp;d=DwMFaQ&amp;c=L5E2d05je37i-dadkViuXA&amp;r=QKv_ztlhAoISx5DIJ55qTCUpcAGkAe44235HRYxlar4&amp;m=DBgpcjOgKK5apq64hkKQ7diMBxm0BkT1UbJ2GQBGEbA&amp;s=FWccQaD96n45ervQOus4jHw3IN_z1dcIboij4Y45f1U&amp;e=\" target=\"_blank\" rel=\"noreferrer noopener\"><em>fticonsulting.com</em></a><em> </em>",
      },
    ],
  },

  {
    slug: "eu-directive-on-combatting-late-payment-and-its-unintended-consequences-on-the-real-economy",
    taxonomy: "Banking and finance",
    dateLabel: "11 December 2023",
    title:
      "EU Directive on combatting late payment and its unintended consequences on the real economy",
    excerpt: "The International Chamber of Commerce (“ICC”) – the institutional representative of more than 45 million businesses in over 170 countries – supports initiatives driven towards creating a culture of reliable and timely payment. While the core purpose of the directive is commendable, closer examination reveals several unintended consequences that raise concerns about its efficacy and broader impacts on contractual freedom, negotiation flexibility, and the vitality of small- and medium-sized enterprises (SMEs).",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/icc-european-union-flag.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/icc-european-union-flag.jpg?w=1080&h=1260&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "p",
        html:
          "The International Chamber of Commerce (“ICC”) – the institutional representative of more than 45 million businesses in over 170 countries – supports initiatives driven towards creating a culture of reliable and timely payment. While the core purpose of the directive is commendable, closer examination reveals several unintended consequences that raise concerns about its efficacy and broader impacts on contractual freedom, negotiation flexibility, and the vitality of small- and medium-sized enterprises (SMEs).",
      },
      { type: "spacer", height: 30 },
      {
        type: "p",
        html:
          "<strong>1. Impairment of Contractual Freedom and Negotiation Flexibility</strong>",
      },
      {
        type: "p",
        html:
          "The Directive imposes a standard payment term limit, limiting the flexibility for businesses to negotiate terms suitable for their unique circumstances. This ‘one-size-fits-all’ approach overlooks the diversity of industries, business models, and financial capabilities among SMEs. In doing so, it inadvertently infringes upon the fundamental right to freedom of contract, impeding organic negotiations that might better suit the parties involved.",
      },
      { type: "spacer", height: 30 },
      { type: "p", html: "<strong>2. Impact on SMEs as Buyers</strong>" },
      {
        type: "p",
        html:
          "SMEs, often operating on tighter margins, face challenges when adhering to the mandated payment periods. By enforcing strict timelines, the Directive can burden SMEs as buyers, potentially constraining their ability to effectively manage cash flow and allocate resources efficiently.",
      },
      { type: "spacer", height: 30 },
      { type: "p", html: "<strong>3. Impact on Liquidity and Access to Finance</strong>" },
      {
        type: "p",
        html:
          "The rigidity of payment terms prescribed by the Directive can exacerbate liquidity issues for SMEs. The delayed inflow of funds disrupts cash flow, hindering their ability to invest in innovation, growth, and employment. Moreover, this could lead to increased reliance on external financing, possibly at higher costs, as delayed payments strain the financial stability of these businesses.",
      },
      { type: "spacer", height: 30 },
      { type: "p", html: "<strong>4. Emphasis on late Government to Businesses payments</strong>" },
      {
        type: "p",
        html:
          "Important reminder is also made on the Government to Business payment which often generate more late payments than in regular business to business payments.",
      },
      {
        type: "p",
        html:
          "The recommendation put forward by ICC is to avoid a strict cap to payments period and rather allow businesses the freedom to negotiate payment terms (if not grossly unfair) as fundamental right.",
      },
      {
        type: "p",
        html:
          "Putting days limitation should only be put forward in absence of an agreement between parties.",
      },
      {
        type: "p",
        html:
          "While the EU Late Payment Directive addresses a critical issue of delayed payments, its unintended consequences risk undermining the very businesses it aims to protect. A nuanced approach that considers the diverse landscape of SMEs, fosters negotiation flexibility, and supports, rather than constrains, their financial health is crucial for sustainable economic growth and development.",
      },
      {
        type: "p",
        html:
          "This statement aims to highlight concerns while suggesting practical recommendations for addressing the unintended consequences of the EU Late Payment Directive. Adjustments or additions can be made to emphasise specific points or to align more closely with your position.",
      },
      {
        type: "p",
        html:
          "ICC remains available to provide further clarification on the points presented above.",
      },
      { type: "spacer", height: 30 },
      { type: "p", html: "" },
    ],
  },



];
